// @ts-nocheck
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { useParams, Link } from "react-router-dom";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Checkbox from "@mui/material/Checkbox";
import moment from "moment";
import Usercard from "../../../components/Usercard";
import Swal from "sweetalert2";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { RiEdit2Fill } from "react-icons/ri";
import api, { baseURL } from "../../../Axios";
import axios from "axios";
import style from "../../../assets/css/navtab.module.css";
import exportAsImage from "./exportToImage";
import Grid from "@mui/material/Grid";

import {
  Form,
  Label,
  Input,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  CardTitle,
  CardText,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import logo from "../../../assets/img/app_logo.png";
import qr from "../../../assets/img/a1-matrimony.png";
import "./stylee.css";
import ProfileSection from "./ProfileSection";
import { InputLabel, MenuItem, Select } from "@mui/material";

const dashboard8 = () => {
  const notiRef = useRef();
  const { id } = useParams();
  const history = useHistory(); // ✅ This is the React Router history
  // Refs for cropper instances and DOM elements
  const exportRef = useRef();
  const cardRef = useRef();

  const scrollContainerRef = useRef(null);

  // ---------- State variables (declare all hooks at the top without conditions) ----------
  const [userData, setUserData] = useState(null);
  const [userdetails, setUserdetails] = useState("");
  const [familydetails, setFamilyDetails] = useState("");
  const [horoscopedetails, setHoroscopeDetails] = useState("");
  const [partnerdetails, setPartnerDetails] = useState("");
  const [profile, setProfile] = useState("");
  const [personalitydetails, setPersonalityDetails] = useState("");
  const [userdocumentdetails, setUserdocumentDetails] = useState("");
  const [membershipType, setMembershipType] = useState("0");
  const [membershiplist, setMembershipList] = useState();
  const [membershipName, setMembershipName] = useState("");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [change, setChange] = useState(false);
  const [educhange, setEduchange] = useState(false);
  const [horo, setHoro] = useState(false);
  const [salarychange, setSalaryChange] = useState(false);
  const [selfiechange, setSelfieChange] = useState(false);
  const [familychange, setFamilyChange] = useState("");
  const [familyverify, setFamilyverify] = useState("0");
  const [aboutchange, setaboutchange] = useState("");
  const [aboutverify, setaboutverify] = useState("0");
  const [subCastechange, setSubCastechange] = useState("");
  const [subverify, setSubverify] = useState("0");
  const [gothramchange, setGothramchange] = useState("");
  const [gothramverify, setGothramverify] = useState("0");

  const [uploadedImage, setUploadedImage] = useState(null);
  const [uploadedImage1, setUploadedImage1] = useState(null);
  const [uploadedImage2, setUploadedImage2] = useState(null);
  const [uploadedImage3, setUploadedImage3] = useState(null);
  const [uploadedImage4, setUploadedImage4] = useState(null);
  const [uploadedImage5, setUploadedImage5] = useState(null);
  const [uploadedImage6, setUploadedImage6] = useState(null);

  const [croppedImage1, setCroppedImage1] = useState(null);
  const [croppedImage2, setCroppedImage2] = useState(null);
  const [croppedImage3, setCroppedImage3] = useState(null);
  const [croppedImage4, setCroppedImage4] = useState(null);
  const [croppedImage5, setCroppedImage5] = useState(null);
  const [croppedImage6, setCroppedImage6] = useState(null);

  const [isCropping1, setIsCropping1] = useState(true);
  const [isCropping2, setIsCropping2] = useState(true);
  const [isCropping3, setIsCropping3] = useState(true);
  const [isCropping4, setIsCropping4] = useState(true);
  const [isCropping5, setIsCropping5] = useState(true);
  const [isCropping6, setIsCropping6] = useState(true);

  const [activeTab, setActiveTab] = useState(1);
  const [active, setActive] = useState(false);
  const [load, setLoad] = useState(false);

  const [state, setState] = useState({
    image1: false,
    image2: false,
    image3: false,
    image4: false,
    image5: false,
    image6: false,
  });
  const { image1, image2, image3, image4, image5, image6 } = state;

  const [view, setView] = useState({});
  const [shortList, setShortList] = useState([]);
  const [proShortList, setProShortList] = useState([]);
  const [likeProfile, setLikedProfiles] = useState([]);
  const [likeMyProfile, setLikedMyProfiles] = useState([]);
  const [intrestProfile, setIntrestProfiles] = useState([]);
  const [intrestMyProfile, setIntrestMyProfiles] = useState([]);
  const [membershipid, setMembershipid] = useState("");
  const [remarks, setRemarks] = useState("");
  const [aadhar, setAadhar] = useState({});
  const [education, setEducation] = useState({});
  const [salarySlip, setSalarySlip] = useState({});
  const [show, setShow] = useState(false);

  // Checkbox states for image verification
  const [aadharChecked, setAadharChecked] = useState({ front: false, back: false });
  const [houseChecked, setHouseChecked] = useState({ img1: false, img2: false, img3: false, img4: false });

  const [showModal, setShowModal] = useState(false);
  const [imageToShow, setImageToShow] = useState("");

  // ---------- Handlers ----------
  const cropperRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);

  const handleImageSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageSrc(URL.createObjectURL(file));
      setCroppedImage(null);
    }
  };

  // ✅ 1: Crop API call
  const handleCropAPI = () => {
    const cropper = cropperRef.current.cropper;

    if (!cropper) {
      alert("Cropper not ready!");
      return;
    }

    // ✅ get cropped image
    cropper
      .getCroppedCanvas({
        width: 600,
        height: 600,
        fillColor: "#fff",
      })
      .toBlob(async (blob) => {
        if (!blob) return;

        // For preview
        setCroppedImage(URL.createObjectURL(blob));

        // API upload
        const formData = new FormData();
        formData.append("image", blob, "profile.jpeg");

        try {
          await api.post(
            `/admin/userProfile/profilePicCropper?userId=${profile.id}`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
        } catch (err) {
          console.log(err);
        }
      });
  };

  // ✅ 2: Verify dropdown API call
  const handleVerify = async (value) => {
    if (!value) return;

    try {
      await api.post(`/admin/approvals/profilePicApproval`, {
        userId: profile.id,
        verified: value,
      });
      Swal.fire({
        icon: "success", // ✅ success, error, warning, info, question
        title: "Saved!",
        text: "Verification saved successfully!",
        confirmButtonText: "OK",
      });
    } catch (err) {
      console.error(err);
    }
  };
  const imageList = [
    profile.image1,
    profile.image2,
    profile.image3,
    profile.image4,
    profile.image5,
    profile.image6,
  ].filter((img) => img !== null);

  // ✅ API gives string: "[0,0,0,0,0,0]"
  const initialVerifyState = (() => {
    try {
      return JSON.parse(profile.multipleImageVerified || "[0,0,0,0,0,0]");
    } catch {
      return [0, 0, 0, 0, 0, 0];
    }
  })();

  const [verifyArray, setVerifyArray] = useState(initialVerifyState);

  // ✅ Store cropped images (index matched with imageList)
  const [croppedImages, setCroppedImages] = useState([]);

  // ✅ Convert base64 → File
  const base64ToFile = (base64, filename) => {
    let arr = base64.split(",");
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let len = bstr.length;
    let u8arr = new Uint8Array(len);
    while (len--) u8arr[len] = bstr.charCodeAt(len);
    return new File([u8arr], filename, { type: mime });
  };

  // ✅ Checkbox update
  const handleVerifyChange = (index, checked) => {
    setVerifyArray((prev) => {
      const update = [...prev];
      update[index] = checked ? 1 : 0;
      return update;
    });
  };

  // ✅ Save cropped output
  const handleCroppedImage = (index, base64) => {
    setCroppedImages((prev) => {
      const arr = [...prev];
      arr[index] = base64;
      return arr;
    });
  };
  const [verifyArr, setVerifyArr] = useState([0, 0, 0, 0, 0, 0]);

  // ✅ Upload all cropped images
  useEffect(() => {
    if (!profile) return;

    // ✅ Load initial verify states from backend
    if (profile.multipleImageVerified) {
      try {
        const arr = JSON.parse(profile.multipleImageVerified);
        setVerifyArr(arr); // ✅ Set checkbox states
      } catch (e) {
        console.log("Invalid verify array:", e);
      }
    }

    // ✅ Load backend images
    setImageSrc1(profile.image1 ? baseURL + profile.image1 : null);
    setImageSrc2(profile.image2 ? baseURL + profile.image2 : null);
    setImageSrc3(profile.image3 ? baseURL + profile.image3 : null);
    setImageSrc4(profile.image4 ? baseURL + profile.image4 : null);
    setImageSrc5(profile.image5 ? baseURL + profile.image5 : null);
    setImageSrc6(profile.image6 ? baseURL + profile.image6 : null);
  }, [profile]);

  // 6 images
  const [imageSrc1, setImageSrc1] = useState(null);
  const [imageSrc2, setImageSrc2] = useState(null);
  const [imageSrc3, setImageSrc3] = useState(null);
  const [imageSrc4, setImageSrc4] = useState(null);
  const [imageSrc5, setImageSrc5] = useState(null);
  const [imageSrc6, setImageSrc6] = useState(null);

  const [cropped1, setCropped1] = useState(null);
  const [cropped2, setCropped2] = useState(null);
  const [cropped3, setCropped3] = useState(null);
  const [cropped4, setCropped4] = useState(null);
  const [cropped5, setCropped5] = useState(null);
  const [cropped6, setCropped6] = useState(null);

  // ✅ CROP refs
  const cropperRef1 = useRef();
  const cropperRef2 = useRef();
  const cropperRef3 = useRef();
  const cropperRef4 = useRef();
  const cropperRef5 = useRef();
  const cropperRef6 = useRef();

  // ------------------------------------------
  // ✅ FILE SELECT HANDLER
  // ------------------------------------------
  const handleSelect = (event, setter) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => setter(reader.result);
    reader.readAsDataURL(file);
  };

  const cropImage1 = async () => {
    const cropper = cropperRef1.current.cropper;
    if (!cropper) return;

    const canvas = cropper.getCroppedCanvas();
    if (!canvas) return;

    canvas.toBlob(async (blob) => {
      if (!blob) return;

      const formData = new FormData();

      formData.append("images", blob, "croppedImage.png");
      if (profile.image2)
        await appendImageFromUrl(formData, profile.image2, "image2.png");

      if (profile.image3)
        await appendImageFromUrl(formData, profile.image3, "image3.png");
      if (profile.image4)
        await appendImageFromUrl(formData, profile.image4, "image4.png");
      if (profile.image5)
        await appendImageFromUrl(formData, profile.image5, "image5.png");
      if (profile.image6)
        await appendImageFromUrl(formData, profile.image6, "image6.png");

      const blobUrl = URL.createObjectURL(blob);
      setCropped1(blobUrl);

      try {
        await api.post(
          `/admin/userProfile/croppedImages?userId=${id}`,
          formData
        );
        const refreshed = await api.get(
          `/admin/userProfile/profileView?userId=${id}`
        );
        setUserData(refreshed.data.data);
      } catch (error) {
        console.error(error);
      }
    });
  };
  const cropImage2 = async () => {
    const cropper = cropperRef2.current.cropper;
    if (!cropper) return;

    const canvas = cropper.getCroppedCanvas();
    if (!canvas) return;

    canvas.toBlob(async (blob) => {
      if (!blob) return;

      const formData = new FormData();

      if (profile.image1)
        await appendImageFromUrl(formData, profile.image1, "image1.png");
      formData.append("images", blob, "croppedImage.png");
      if (profile.image3)
        await appendImageFromUrl(formData, profile.image3, "image3.png");
      if (profile.image4)
        await appendImageFromUrl(formData, profile.image4, "image4.png");
      if (profile.image5)
        await appendImageFromUrl(formData, profile.image5, "image5.png");
      if (profile.image6)
        await appendImageFromUrl(formData, profile.image6, "image6.png");

      const blobUrl = URL.createObjectURL(blob);
      setCropped2(blobUrl);

      try {
        await api.post(
          `/admin/userProfile/croppedImages?userId=${id}`,
          formData
        );
        const refreshed = await api.get(
          `/admin/userProfile/profileView?userId=${id}`
        );
        setUserData(refreshed.data.data);
      } catch (error) {
        console.error(error);
      }
    });
  };
  const cropImage3 = async () => {
    const cropper = cropperRef3.current.cropper;
    if (!cropper) return;

    const canvas = cropper.getCroppedCanvas();
    if (!canvas) return;

    canvas.toBlob(async (blob) => {
      if (!blob) return;

      const formData = new FormData();

      if (profile.image1)
        await appendImageFromUrl(formData, profile.image1, "image1.png");
      if (profile.image2)
        await appendImageFromUrl(formData, profile.image2, "image2.png");

      formData.append("images", blob, "croppedImage.png");

      if (profile.image4)
        await appendImageFromUrl(formData, profile.image4, "image4.png");
      if (profile.image5)
        await appendImageFromUrl(formData, profile.image5, "image5.png");
      if (profile.image6)
        await appendImageFromUrl(formData, profile.image6, "image6.png");

      const blobUrl = URL.createObjectURL(blob);
      setCropped3(blobUrl);

      try {
        await api.post(
          `/admin/userProfile/croppedImages?userId=${id}`,
          formData
        );
        const refreshed = await api.get(
          `/admin/userProfile/profileView?userId=${id}`
        );
        setUserData(refreshed.data.data);
      } catch (error) {
        console.error(error);
      }
    });
  };

  const cropImage4 = async () => {
    const cropper = cropperRef4.current.cropper;
    if (!cropper) return;

    const canvas = cropper.getCroppedCanvas();
    if (!canvas) return;

    canvas.toBlob(async (blob) => {
      if (!blob) return;

      const formData = new FormData();

      if (profile.image1)
        await appendImageFromUrl(formData, profile.image1, "image1.png");
      if (profile.image2)
        await appendImageFromUrl(formData, profile.image2, "image2.png");

      if (profile.image3)
        await appendImageFromUrl(formData, profile.image3, "image3.png");
      formData.append("images", blob, "croppedImage.png");

      if (profile.image5)
        await appendImageFromUrl(formData, profile.image5, "image5.png");
      if (profile.image6)
        await appendImageFromUrl(formData, profile.image6, "image6.png");

      const blobUrl = URL.createObjectURL(blob);
      setCropped4(blobUrl);

      try {
        await api.post(
          `/admin/userProfile/croppedImages?userId=${id}`,
          formData
        );
        const refreshed = await api.get(
          `/admin/userProfile/profileView?userId=${id}`
        );
        setUserData(refreshed.data.data);
      } catch (error) {
        console.error(error);
      }
    });
  };
  const cropImage5 = async () => {
    const cropper = cropperRef5.current.cropper;
    if (!cropper) return;

    const canvas = cropper.getCroppedCanvas();
    if (!canvas) return;

    canvas.toBlob(async (blob) => {
      if (!blob) return;

      const formData = new FormData();
      if (profile.image1)
        await appendImageFromUrl(formData, profile.image1, "image1.png");
      if (profile.image2)
        await appendImageFromUrl(formData, profile.image2, "image2.png");

      if (profile.image3)
        await appendImageFromUrl(formData, profile.image3, "image3.png");
      if (profile.image4)
        await appendImageFromUrl(formData, profile.image4, "image4.png");
      formData.append("images", blob, "croppedImage.png");

      if (profile.image6)
        await appendImageFromUrl(formData, profile.image6, "image6.png");

      const blobUrl = URL.createObjectURL(blob);
      setCropped5(blobUrl);

      try {
        await api.post(
          `/admin/userProfile/croppedImages?userId=${id}`,
          formData
        );
        const refreshed = await api.get(
          `/admin/userProfile/profileView?userId=${id}`
        );
        setUserData(refreshed.data.data);
      } catch (error) {
        console.error(error);
      }
    });
  };

  const cropImage6 = async () => {
    const cropper = cropperRef6.current.cropper;
    if (!cropper) return;

    const canvas = cropper.getCroppedCanvas();
    if (!canvas) return;

    canvas.toBlob(async (blob) => {
      if (!blob) return;

      const formData = new FormData();
      if (profile.image1)
        await appendImageFromUrl(formData, profile.image1, "image1.png");
      if (profile.image2)
        await appendImageFromUrl(formData, profile.image2, "image2.png");

      if (profile.image3)
        await appendImageFromUrl(formData, profile.image3, "image3.png");
      if (profile.image4)
        await appendImageFromUrl(formData, profile.image4, "image4.png");

      if (profile.image5)
        await appendImageFromUrl(formData, profile.image5, "image5.png");
      formData.append("images", blob, "croppedImage.png");

      const blobUrl = URL.createObjectURL(blob);
      setCropped6(blobUrl);

      try {
        await api.post(
          `/admin/userProfile/croppedImages?userId=${id}`,
          formData
        );
        const refreshed = await api.get(
          `/admin/userProfile/profileView?userId=${id}`
        );
        setUserData(refreshed.data.data);
      } catch (error) {
        console.error(error);
      }
    });
  };
  const appendImageFromUrl = async (formData, url, name) => {
    const response = await fetch(url); // fetch image as blob
    const blob = await response.blob();
    formData.append("images", blob, name);
  };
  const handleVerifyToggle = (index, value) => {
    const arr = [...verifyArr];
    arr[index] = value ? 1 : 0;
    setVerifyArr(arr);
  };

  // ✅ Save all verification
  const saveAllVerification = async () => {
    try {
      await api.post("/admin/approvals/multipleImageApproval", {
        userId: id,
        verified: verifyArr,
      });

      Swal.fire({
        icon: "success", // ✅ success, error, warning, info, question
        title: "Saved!",
        text: "Verification saved successfully!",
        confirmButtonText: "OK",
      });
    } catch (err) {
      console.log("Save Error:", err);
    }
  };

  const renderBlock = (
    label,
    src,
    setSrc,
    cropperRef,
    cropped,
    setCropped,
    keyName,
    keyIndex
  ) => (
    <div style={{ marginBottom: "40px" }}>
      <h5>{label}</h5>

      {!src && (
        <input
          type="file"
          accept="image/*"
          onChange={(e) => handleSelect(e, setSrc)}
        />
      )}

      {src && (
        <div style={{ display: "flex", gap: "25px", marginTop: "20px" }}>
          <div>
            <Cropper
              src={src}
              ref={cropperRef}
              style={{ height: 200, width: 300 }}
              aspectRatio={1}
              viewMode={1}
              guides={false}
              background={false}
            />

            <button
              onClick={() => {
                if (keyName === "image1") cropImage1();
                if (keyName === "image2") cropImage2();
                if (keyName === "image3") cropImage3();
                if (keyName === "image4") cropImage4();
                if (keyName === "image5") cropImage5();
                if (keyName === "image6") cropImage6();
              }}
              style={{
                marginTop: "15px",
                padding: "8px 14px",
                background: "#4caf50",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
              }}
            >
              Crop & Upload
            </button>

            {/* ✅ Image Verification Checkbox */}
            <div style={{ marginTop: "15px" }}>
              <label style={{ fontWeight: "600", display: "flex", alignItems: "center", cursor: "pointer" }}>
                <div
                  onClick={() => handleVerifyToggle(keyIndex, verifyArr[keyIndex] !== 1)}
                  style={{
                    width: "20px",
                    height: "20px",
                    border: "2px solid #000",
                    borderRadius: "4px",
                    marginRight: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: verifyArr[keyIndex] === 1 ? "#000" : "#fff",
                    cursor: "pointer"
                  }}
                >
                  {verifyArr[keyIndex] === 1 && (
                    <span style={{ color: "#fff", fontSize: "14px", fontWeight: "bold" }}>✓</span>
                  )}
                </div>
                Verify this image
              </label>
            </div>
          </div>

          {cropped && (
            <div>
              <h6>Cropped Preview</h6>
              <img
                src={cropped}
                style={{
                  width: 200,
                  height: 200,
                  borderRadius: "10px",
                  objectFit: "cover",
                }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );

  useEffect(() => {
    if (!id) {
      setLoading(false);
      return;
    }
    setLoading(true);
    api
      .get(`/admin/userProfile/profileView?userId=${id}`)
      .then((res) => {
        const data = res.data.data;
        setUserData(data);
        setProfile(data && data.profile ? data.profile : "");
        setUserdetails(data && data.userDetails ? data.userDetails : "");
        setFamilyDetails(data && data.userFamily ? data.userFamily : "");
        setHoroscopeDetails(data && data.horoscope ? data.horoscope : "");
        setPartnerDetails(data && data.preference ? data.preference : "");
        setPersonalityDetails(
          data && data.personalityDetails ? data.personalityDetails : ""
        );
        setUserdocumentDetails(data && data.docs ? data.docs : "");
        setMembershipType(
          data && data.membershipType ? data.membershipType : "0"
        );
        setMembershipName(
          data && data.membershipName ? data.membershipName : ""
        );

        // Initialize checkbox states based on API verification status
        if (data && data.docs) {
          setAadharChecked({
            front: data.docs.aadharFrontVerified === 1,
            back: data.docs.aadharBackVerified === 1,
          });
          setHouseChecked({
            img1: data.docs.housePic1Verified === 1,
            img2: data.docs.housePic2Verified === 1,
            img3: data.docs.housePic3Verified === 1,
            img4: data.docs.housePic4Verified === 1,
          });
        }

        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, [id, change, educhange, horo, salarychange, selfiechange]);
  // When image is uploaded

  useEffect(() => {
    console.log(profile);

    if (profile) {
      if (profile.profileCropped) {
        setImageSrc(baseURL + profile.profileCropped);
      } else if (profile.profilePic) {
        setImageSrc(baseURL + profile.profilePic);
      }
    }
  }, [profile]);
  // Checkbox toggle for images
  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  // Fetch user data whenever id or triggers change

  const handleHoroscopeUpload = async (e) => {
    const file = e.target.files[0]; // Get the selected file
    if (!file) return;

    // Optional: Validate file type/size
    if (!file.type.startsWith("image/")) {
      alert("Please select an image file.");
      return;
    }

    const formData = new FormData();
    formData.append("image", file);

    try {
      // Make API call and wait for response
      const response = await api.post(
        `/admin/userProfile/adminUploadedHoroscope?userId=${profile.id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      api.get(`/admin/userProfile/profileView?userId=${id}`).then((res) => {
        const data = res.data.data;
        setUserdocumentDetails(data && data.docs ? data.docs : "");
      });
    } catch (err) {
      console.error(err);
      alert("Something went wrong during upload.");
    }
  };

  // Fetch membership list
  useEffect(() => {
    api.get("/admin/membership/viewAllMembership").then((res) => {
      setMembershipList(res.data.data);
    });
  }, [change]);

  // Set current membership ID when membership list and name are available
  useEffect(() => {
    if (membershiplist && membershipName) {
      const currentMembership = membershiplist.find(
        (m) => m.name.toLowerCase() === membershipName.toLowerCase()
      );
      if (currentMembership) {
        setMembershipid(currentMembership.id.toString());
      }
    }
  }, [membershiplist, membershipName]);

  function imageVerify(userId, value) {
    const multipleImageVerified = [
      image1 ? 1 : image1 === 2 ? 2 : 0,
      image2 ? 1 : image2 === 2 ? 2 : 0,
      image3 ? 1 : image3 === 2 ? 2 : 0,
      image4 ? 1 : image4 === 2 ? 2 : 0,
      image5 ? 1 : image5 === 2 ? 2 : 0,
      image6 ? 1 : image6 === 2 ? 2 : 0,
    ];
    api
      .post("/admin/adminDashboard/multipleImageVerified", {
        id: userId,
        multipleImageVerified,
        verified: value,
      })
      .then((res) => {
        Swal.fire(res.data.data);
        setChange((prev) => !prev);
      });
  }

  function verifyAbout(userId) {
    api
      .post("/admin/approvals/aboutMyselfApproval", {
        userId: userId,
        verified: aboutverify === "1" ? "0" : "1",
        aboutUser: aboutchange,
      })
      .then((res) => {
        Swal.fire(res.data.data);
        setChange((prev) => !prev);
      });
  }

  function verifyFamily(userId) {
    api
      .post("/admin/approvals/familyApproval", {
        userId: userId,
        verified: familyverify === "1" ? "0" : "1",
        aboutFamily: familychange,
      })
      .then((res) => {
        Swal.fire(res.data.data);
        setChange((prev) => !prev);
      });
  }

  function imageveriy(userId, value) {
    const multipleImageVerified = [
      image1 ? 1 : image1 === 2 ? 2 : 0,
      image2 ? 1 : image2 === 2 ? 2 : 0,
      image3 ? 1 : image3 === 2 ? 2 : 0,
      image4 ? 1 : image4 === 2 ? 2 : 0,
      image5 ? 1 : image5 === 2 ? 2 : 0,
      image6 ? 1 : image6 === 2 ? 2 : 0,
    ];
    api
      .post("/admin/adminDashboard/multipleImageVerified", {
        id: userId,
        multipleImageVerified,
        verified: value,
      })
      .then((res) => {
        Swal.fire(res.data.data);
        setChange((prev) => !prev);
      });
  }

  function verifieds(userId, value) {
    api
      .post("/admin/approvals/educationDetailsApproval", {
        userId: userId,
        verified: value,
      })
      .then((res) => {
        setEduchange((prev) => !prev);
      });
  }

  function verifihoro(userId, value) {
    api
      .post("/admin/approvals/horoscopeApproval", {
        userId: userId,
        verified: value,
      })
      .then((res) => {
        setHoro((prev) => !prev);
      });
  }

  function salaryVerifys(userId) {
    api
      .post("/admin/adminDashboard/salaryVerified", { id: userId })
      .then((res) => {
        setSalaryChange((prev) => !prev);
      });
  }

  function selfieVerify(userId) {
    api
      .post("/admin/adminDashboard/selfieVerified", { id: userId })
      .then((res) => {
        setSelfieChange((prev) => !prev);
      });
  }

  function activee(userId) {
    api.post("/admin/manageuserProfile/deleteUser", { id: userId }).then(() => {
      setActive((prev) => !prev);
    });
  }

  function deletee(userId) {
    api
      .post("/admin/manageuserProfile/terminateUser", { id: userId })
      .then(() => {
        setChange((prev) => !prev);
      });
  }

  // function profileShortlist() {
  //   api
  //     .post("/admin/adminDashboard/userActivity", {
  //       id: profile.id,
  //       value: "shortlistedMyProfile",
  //     })
  //     .then((res) => {
  //       setProShortList(res.data.data);
  //     });
  // }

  function shortlist() {
    api
      .post("/admin/adminDashboard/userActivity", {
        id: profile.id,
        value: "shortlistedProfiles",
      })
      .then((res) => {
        setShortList(res.data.data);
      });
  }

  function likedProfile() {
    api
      .post("/admin/adminDashboard/userActivity", {
        id: profile.id,
        value: "likedProfiles",
      })
      .then((res) => {
        setLikedProfiles(res.data.data);
      });
  }

  function likedMyProfile() {
    api
      .post("/admin/adminDashboard/userActivity", {
        id: profile.id,
        value: "likedMyProfile",
      })
      .then((res) => {
        setLikedMyProfiles(res.data.data);
      });
  }

  function interestedMyProfile() {
    api
      .post("/admin/adminDashboard/userActivity", {
        id: profile.id,
        value: "interestedMyProfile",
      })
      .then((res) => {
        setIntrestMyProfiles(res.data.data);
      });
  }

  function interestedProfiles() {
    api
      .post("/admin/adminDashboard/userActivity", {
        id: profile.id,
        value: "interestedProfiles",
      })
      .then((res) => {
        setIntrestProfiles(res.data.data);
      });
  }

  // Document upload handlers
  const handleDocChange = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("aadhar", file);
      api
        .post(`/admin/manageUserProfile/addUserDocs?id=${id}`, formData)
        .then(() => {
          setChange((prev) => !prev);
          setAadhar({}); // reset state
        });
    }
  };

  const handleEducationChange = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("education", file);
      api
        .post(`/admin/manageUserProfile/addUserDocs?id=${id}`, formData)
        .then(() => {
          setChange((prev) => !prev);
          setEducation({});
        });
    }
  };

  const handleSalaryChange = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("salarySlip", file);
      api
        .post(`/admin/manageUserProfile/addUserDocs?id=${id}`, formData)
        .then(() => {
          setChange((prev) => !prev);
          setSalarySlip({});
        });
    }
  };

  // Membership activation
  function activeMembershipManual() {
    api
      .post("/admin/membership/activateMembershipManualy", {
        userId: Number(profile.id),
        id: Number(membershipid),
        remarks: remarks,
      })
      .then((res) => {
        Swal.fire("Success", res.data.data || "Membership updated successfully", "success");
        // Find and set the membership name
        const selectedMembership = membershiplist && membershiplist.find(m => m.id === Number(membershipid));
        if (selectedMembership) {
          setMembershipName(selectedMembership.name);
        }
        setMembershipType(membershipid);
        setChange((prev) => !prev);
      })
      .catch((err) => {
        Swal.fire("Error", (err.response && err.response.data && err.response.data.message) || "Failed to update membership", "error");
      });
  }

  // Export as PDF functionality
  const exportAsPDF = () => {
    if (!cardRef.current) {
      console.error("cardRef is not assigned to any DOM element.");
      return;
    }
    html2canvas(cardRef.current)
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        pdf.addImage(imgData, "PNG", 0, 0);
        pdf.save("profile.pdf");
      })
      .catch((error) => {
        console.error("Error capturing the element:", error);
      });
    setShow(false);
  };

  const handlePreview = () => {
    setShow(true);
  };

  const handleDownload = () => {
    if (show) {
      exportAsPDF();
    } else {
      setShow(true);
    }
  };

  const handleImageClick = (imageSrc) => {
    setImageToShow(imageSrc);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // Scroll handler for galleries
  const handleScroll = (scrollOffset) => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: scrollOffset,
        behavior: "smooth",
      });
    }
  };

  // Image upload handlers for images 1 through 6
  const handleImageUpload1 = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setUploadedImage1(reader.result);
      reader.readAsDataURL(file);

      const formData = new FormData();
      formData.append("image1", file, "croppedImage.png");

      try {
        await axios.post(
          `/admin/userProfile/croppedImages?userId=${id}`,
          formData
        );
        setChange((prev) => !prev);
      } catch (error) {
        console.error("Error uploading image1:", error);
      }
    }
  };

  const handleImageUpload2 = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setUploadedImage2(reader.result);
      reader.readAsDataURL(file);

      const formData = new FormData();
      formData.append("image2", file, "croppedImage.png");

      try {
        await axios.post(
          `/admin/userProfile/croppedImages?userId=${id}`,
          formData
        );
        setChange((prev) => !prev);
      } catch (error) {
        console.error("Error uploading image2:", error);
      }
    }
  };

  const handleImageUpload3 = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setUploadedImage3(reader.result);
      reader.readAsDataURL(file);

      const formData = new FormData();
      formData.append("image3", file, "croppedImage.png");

      try {
        await axios.post(
          `/admin/userProfile/croppedImages?userId=${id}`,
          formData
        );
        setChange((prev) => !prev);
      } catch (error) {
        console.error("Error uploading image3:", error);
      }
    }
  };

  const handleImageUpload4 = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setUploadedImage4(reader.result);
      reader.readAsDataURL(file);

      const formData = new FormData();
      formData.append("image4", file, "croppedImage.png");

      try {
        await axios.post(
          `/admin/userProfile/croppedImages?userId=${id}`,
          formData
        );
        setChange((prev) => !prev);
      } catch (error) {
        console.error("Error uploading image4:", error);
      }
    }
  };

  const handleImageUpload5 = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setUploadedImage5(reader.result);
      reader.readAsDataURL(file);

      const formData = new FormData();
      formData.append("image5", file, "croppedImage.png");

      try {
        await axios.post(
          `/admin/userProfile/croppedImages?userId=${id}`,
          formData
        );
        setChange((prev) => !prev);
      } catch (error) {
        console.error("Error uploading image5:", error);
      }
    }
  };

  const handleImageUpload6 = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setUploadedImage6(reader.result);
      reader.readAsDataURL(file);

      const formData = new FormData();
      formData.append("image6", file, "croppedImage.png");

      try {
        await axios.post(
          `/admin/userProfile/croppedImages?userId=${id}`,
          formData
        );
        setChange((prev) => !prev);
      } catch (error) {
        console.error("Error uploading image6:", error);
      }
    }
  };

  // Image verification function invoked with user id and verified value
  function Imgverify(userId, value) {
    api
      .post("/admin/adminDashboard/imageVerified", {
        id: userId,
        verified: value,
      })
      .then(() => {
        // Refresh user data after verification
        api
          .get(`/admin/userProfile/profileView?userId=${userId}`)
          .then((res) => {
            setUserData(res.data.data);
            setLoading(false);
          })
          .catch((error) => {
            console.error("Error fetching user details:", error);
            setLoading(false);
          });
      });
  }

  // ---------- Conditional render states ----------
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading profile</p>;
  if (!userData) return <p>No profile data found</p>;

  // Destructure userData for easier access
  const { Profile, userDetails, userFamily, horoscope, docs, preference } =
    userData;
  const handleEditClick = () => {
    history.push(`/updatedetails/${id}`);
  };

  const handleEduEditClick = () => {
    history.push(`/updateedu/${id}`);
  };
  const handleRegEditClick = () => {
    history.push(`/updatereligion/${id}`);
  };
  const handleLocEditClick = () => {
    history.push(`/updatelocation/${id}`);
  };
  const handleexpectEditClick = () => {
    history.push(`/updateexpectations/${id}`);
  };
  const handleAboutFamilyEditClick = () => {
    history.push(`/updateaboutfamily/${id}`);
  };
  const handleFamilyEditClick = () => {
    history.push(`/updatefamily/${id}`);
  };
  const handlePartnerEditClick = () => {
    history.push(`/updatepartner/${id}`);
  };
  const handleaboutMyselfEditClick = () => {
    history.push(`/updateaboutmyself/${id}`);
  };
  const handleContactEditClick = () => {
    history.push(`/updatecontact/${id}`);
  };
  const handleKulamDetailsEditClick = () => {
    history.push(`/updatekulamdetails/${id}`);
  };
  const handleAddressDetailsEditClick = () => {
    history.push(`/updateaddressdetails/${id}`);
  };
  const handleHouseImagesEditClick = () => {
    history.push(`/updatehouseimages/${id}`);
  };
  const handleFamilyAssetsEditClick = () => {
    history.push(`/updatefamilyassets/${id}`);
  };
  const handleHobbiesEditClick = () => {
    history.push(`/updatehobbies/${id}`);
  };
  // Aadhar verification - sends selected indexes when Verify is clicked
  const AadharVerify = async (userId, action) => {
    try {
      if (action === "verify") {
        var indexes = [];
        if (aadharChecked.front) indexes.push(0);
        if (aadharChecked.back) indexes.push(1);

        if (indexes.length === 0) {
          Swal.fire("No Selection", "Please select at least one image to verify", "warning");
          return;
        }

        const response = await api.post("/admin/approvals/aadharVerification", {
          userId: userId,
          verifiedIndexes: indexes,
        });

        // Show success modal
        Swal.fire("Success", "Aadhar verification updated successfully", "success");
      } else if (action === "waiting") {
        await api.post("/admin/approvals/aadharVerification", {
          userId: userId,
          verified: false,
        });

        // Show success modal
        Swal.fire("Success", "Aadhar status updated to Waiting", "success");
      }

      // Fetch updated data and update checkbox states
      api.get(`/admin/userProfile/profileView?userId=${userId}`).then((res) => {
        const data = res.data.data;
        setUserdocumentDetails(data && data.docs ? data.docs : "");

        // Update checkbox states based on new verification status
        if (data && data.docs) {
          setAadharChecked({
            front: data.docs.aadharFrontVerified === 1,
            back: data.docs.aadharBackVerified === 1,
          });
        }
      });
      console.log("Aadhaar Verification updated");
    } catch (err) {
      console.error("Error updating Aadhaar Verification:", err);

      // Show error modal
      Swal.fire("Error", (err.response && err.response.data && err.response.data.message) || "Failed to update Aadhar verification", "error");
    }
  };

  // House verification - sends selected indexes when Verify is clicked
  const HouseVerify = async (userId, action) => {
    try {
      if (action === "verify") {
        var indexes = [];
        if (houseChecked.img1) indexes.push(0);
        if (houseChecked.img2) indexes.push(1);
        if (houseChecked.img3) indexes.push(2);
        if (houseChecked.img4) indexes.push(3);

        if (indexes.length === 0) {
          Swal.fire("No Selection", "Please select at least one image to verify", "warning");
          return;
        }

        const response = await api.post("/admin/approvals/housePicApproval", {
          userId: userId,
          verifiedIndexes: indexes,
        });

        // Show success modal
        Swal.fire("Success", `House image${indexes.length > 1 ? 's' : ''} verification updated successfully`, "success");
      } else if (action === "waiting") {
        await api.post("/admin/approvals/housePicApproval", {
          userId: userId,
          verified: false,
        });

        // Show success modal
        Swal.fire("Success", "House images status updated to Waiting", "success");
      }

      // Fetch updated data and update checkbox states
      api.get(`/admin/userProfile/profileView?userId=${userId}`).then((res) => {
        const data = res.data.data;
        setUserdocumentDetails(data && data.docs ? data.docs : "");

        // Update checkbox states based on new verification status
        if (data && data.docs) {
          setHouseChecked({
            img1: data.docs.housePic1Verified === 1,
            img2: data.docs.housePic2Verified === 1,
            img3: data.docs.housePic3Verified === 1,
            img4: data.docs.housePic4Verified === 1,
          });
        }
      });
      console.log("House image verification updated");
    } catch (err) {
      console.error("Error updating house image verification:", err);

      // Show error modal
      Swal.fire("Error", (err.response && err.response.data && err.response.data.message) || "Failed to update house image verification", "error");
    }
  };

  return (
    <div className="col-12">
      <Row>
        <Col xs={12} md={12}>
          <div className="page-title">
            <div className="float-left">
              <h1 className="title">Members Full Profile</h1>
            </div>
          </div>
          <div className="col-12">
            <section className="box ">
              <header
                className="panel_header"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "10px 2rem",
                  }}
                >
                  <h2
                    style={{ textTransform: "capitalize", marginRight: "2px" }}
                  >
                    {profile ? profile.userName : "Name"}
                  </h2>
                  <span
                    className="badge"
                    style={{
                      borderRadius: "10px",
                      fontWeight: "500",
                      backgroundColor: "black",
                    }}
                  >
                    {profile && profile.profileId
                      ? profile.profileId
                      : "Profile ID not available"}
                  </span>
                </div>
                <div style={{ marginTop: "50px" }}>
                  <a href="/dashboard">
                    <button
                      onClick={() => deletee(profile.id)}
                      style={{
                        backgroundColor: "#eb3143",
                        color: "white",
                        border: "None",
                        fontSize: "14px",
                        padding: "2px 10px",
                        marginRight: "20px",
                        fontWeight: "500",
                      }}
                    >
                      Delete
                    </button>
                  </a>
                  <button
                    onClick={() => profile && profile.id && activee(profile.id)}
                    style={{
                      backgroundColor: "green",
                      color: "white",
                      border: "None",
                      fontSize: "14px",
                      padding: "2px 10px",
                      marginRight: "20px",
                      fontWeight: "500",
                    }}
                  >
                    {profile && profile.status === "active"
                      ? "Active"
                      : "Inactive"}
                  </button>
                </div>
              </header>
              <div style={{ backgroundColor: "white", padding: "25px" }}>
                <div id={style.scrollContainer} ref={scrollContainerRef} style={{ display: "flex", alignItems: "center" }}>
                  <Nav tabs id={style.navPane} style={{ paddingBottom: "2px", display: "flex", flexWrap: "nowrap" }}>
                    <NavItem>
                      <NavLink
                        style={
                          activeTab === 1
                            ? {
                              backgroundColor: "#000",
                              color: "#fff",
                              borderRadius: "8px",
                              padding: "10px 20px",
                              border: "none",
                              fontWeight: "600",
                              cursor: "pointer",
                            }
                            : {
                              backgroundColor: "#fff",
                              color: "#000",
                              borderRadius: "8px",
                              padding: "10px 20px",
                              border: "1px solid #ddd",
                              fontWeight: "500",
                              cursor: "pointer",
                            }
                        }
                        onClick={() => setActiveTab(1)}
                      >
                        Profile Details
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        style={
                          activeTab === 2
                            ? {
                              backgroundColor: "#000",
                              color: "#fff",
                              borderRadius: "8px",
                              padding: "10px 20px",
                              border: "none",
                              fontWeight: "600",
                              cursor: "pointer",
                            }
                            : {
                              backgroundColor: "#fff",
                              color: "#000",
                              borderRadius: "8px",
                              padding: "10px 20px",
                              border: "1px solid #ddd",
                              fontWeight: "500",
                              cursor: "pointer",
                            }
                        }
                        onClick={() => setActiveTab(2)}
                      >
                        Horoscope Details
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        style={
                          activeTab === 3
                            ? {
                              backgroundColor: "#000",
                              color: "#fff",
                              borderRadius: "8px",
                              padding: "10px 20px",
                              border: "none",
                              fontWeight: "600",
                              cursor: "pointer",
                            }
                            : {
                              backgroundColor: "#fff",
                              color: "#000",
                              borderRadius: "8px",
                              padding: "10px 20px",
                              border: "1px solid #ddd",
                              fontWeight: "500",
                              cursor: "pointer",
                            }
                        }
                        onClick={() => setActiveTab(3)}
                      >
                        Verification
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        style={
                          activeTab === 6
                            ? {
                              backgroundColor: "#000",
                              color: "#fff",
                              borderRadius: "8px",
                              padding: "10px 20px",
                              border: "none",
                              fontWeight: "600",
                              cursor: "pointer",
                            }
                            : {
                              backgroundColor: "#fff",
                              color: "#000",
                              borderRadius: "8px",
                              padding: "10px 20px",
                              border: "1px solid #ddd",
                              fontWeight: "500",
                              cursor: "pointer",
                            }
                        }
                        onClick={() => setActiveTab(6)}
                      >
                        Photo Verification
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={
                          activeTab === 7
                            ? {
                              backgroundColor: "#000",
                              color: "#fff",
                              borderRadius: "8px",
                              padding: "10px 20px",
                              border: "none",
                              fontWeight: "600",
                              cursor: "pointer",
                            }
                            : {
                              backgroundColor: "#fff",
                              color: "#000",
                              borderRadius: "8px",
                              padding: "10px 20px",
                              border: "1px solid #ddd",
                              fontWeight: "500",
                              cursor: "pointer",
                            }
                        }
                        onClick={() => {
                          setActiveTab(7);
                        }}
                      >
                        Membership plan
                      </NavLink>
                    </NavItem>
                    {/* <NavItem>
                      <NavLink
                        className="active"
                        id={style.tab8}
                        style={
                          activeTab === 12
                            ? {
                                color: "black",
                                borderBottom: "2px solid black",
                              }
                            : {}
                        }
                        onClick={() => {
                          setActiveTab(12);
                          shortlist();
                        }}
                      >
                        Shortlisted My Profile
                      </NavLink>
                    </NavItem> */}
                    {/* <NavItem>
                      <NavLink
                        className="active"
                        id={style.tab8}
                        style={
                          activeTab === 13
                            ? {
                                color: "black",
                                borderBottom: "2px solid black",
                              }
                            : {}
                        }
                        onClick={() => {
                          setActiveTab(13);
                          likedMyProfile();
                        }}
                      >
                        Liked Profiles
                      </NavLink>
                    </NavItem> */}
                    {/* <NavItem>
                      <NavLink
                        className="active"
                        id={style.tab8}
                        style={
                          activeTab === 14
                            ? {
                                color: "black",
                                borderBottom: "2px solid black",
                              }
                            : {}
                        }
                        onClick={() => {
                          setActiveTab(14);
                          likedProfile();
                        }}
                      >
                        Liked My Profile
                      </NavLink>
                    </NavItem> */}
                    {/* <NavItem>
                      <NavLink
                        className="active"
                        id={style.tab8}
                        style={
                          activeTab === 15
                            ? {
                                color: "black",
                                borderBottom: "2px solid black",
                              }
                            : {}
                        }
                        onClick={() => {
                          setActiveTab(15);
                          interestedMyProfile();
                        }}
                      >
                        Interested in my Profile
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className="active"
                        id={style.tab8}
                        style={
                          activeTab === 16
                            ? {
                                color: "black",
                                borderBottom: "2px solid black",
                              }
                            : {}
                        }
                        onClick={() => {
                          setActiveTab(16);
                          interestedProfiles();
                        }}
                      >
                        Interested Profiles
                      </NavLink>
                    </NavItem> */}
                  </Nav>
                </div>

                <TabContent
                  activeTab={`${activeTab}`}
                  style={{ borderColor: "#fff0", borderTop: "1px solid #fff9" }}
                >
                  <TabPane tabId="1">
                    <Row>
                      <Col sm="12">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          {/* {show ? (
                            false
                          ) : (
                            <button
                              className="btn btn-primary"
                              onClick={handleDownload}
                            >
                              Preview & Download Profile
                            </button>
                          )} */}
                        </div>
                        <div
                          ref={cardRef}
                          style={{ display: show ? "block" : "none" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <button
                              className="btn btn-primary"
                              onClick={handleDownload}
                            >
                              Download Profile
                            </button>
                          </div>
                          <Card style={{ padding: "40px" }}>
                            {" "}
                            <div className="row">
                              {" "}
                              <div className="col-sm-12 col-md-12 col-lg-6">
                                <table
                                  className="table  table-borderless"
                                  style={{ border: "None" }}
                                >
                                  <tbody>
                                    <tr>
                                      {profile && profile.userName ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Name
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          paddingLeft: "100px",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {profile && profile.userName
                                          ? profile.userName
                                          : false}
                                      </td>
                                    </tr>
                                    <tr>
                                      {profile && profile.dob ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Date of Birth
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          paddingLeft: "100px",
                                        }}
                                      >
                                        {profile && profile.dob
                                          ? moment(profile.dob).format(
                                            "DD-MM-YYYY"
                                          )
                                          : false}
                                      </td>
                                    </tr>
                                    <tr>
                                      {profile && profile.phone ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Phone no.
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          paddingLeft: "100px",
                                        }}
                                      >
                                        {profile &&
                                          profile.countryCode &&
                                          profile.phone ? (
                                          <span className="me-1">
                                            {profile.countryCode}
                                          </span>
                                        ) : null}
                                        {profile && profile.phone
                                          ? profile.phone
                                          : false}
                                      </td>
                                    </tr>
                                    <tr>
                                      {profile && profile.gender ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Gender
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          paddingLeft: "100px",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {profile && profile.gender
                                          ? profile.gender
                                          : false}
                                      </td>
                                    </tr>
                                    {profile && (
                                      <tr>
                                        {profile && profile.email ? (
                                          <td
                                            style={{
                                              borderTop: "none",
                                              fontWeight: "600",
                                              width: "420px",
                                            }}
                                          >
                                            Email
                                          </td>
                                        ) : (
                                          false
                                        )}
                                        <td
                                          style={{
                                            borderTop: "none",
                                            paddingLeft: "50px",
                                          }}
                                        >
                                          {profile && profile.email
                                            ? profile.email
                                            : false}
                                        </td>
                                      </tr>
                                    )}
                                    <tr>
                                      {userdetails &&
                                        userdetails.profileCreatedBy ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          ProfileCreatedBy
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {userdetails &&
                                          userdetails.profileCreatedBy
                                          ? userdetails.profileCreatedBy
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {personalitydetails.height ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Height
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {personalitydetails
                                          ? personalitydetails.height
                                          : false}
                                      </td>
                                    </tr>
                                    <tr>
                                      {personalitydetails.weight ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Weight
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {personalitydetails
                                          ? personalitydetails.weight
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {userdetails &&
                                        userdetails.maritalStatus ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Marital Status
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {userdetails &&
                                          userdetails.maritalStatus
                                          ? userdetails.maritalStatus
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {userdetails &&
                                        userdetails.numberOfChildren ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Number Of Children
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {userdetails &&
                                          userdetails.numberOfChildren
                                          ? userdetails.numberOfChildren
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {userdetails &&
                                        userdetails.childrenStayingWithMe ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Children Staying With Me
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {userdetails &&
                                          userdetails.childrenStayingWithMe
                                          ? userdetails.childrenStayingWithMe
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {partnerdetails &&
                                        partnerdetails.motherTongue ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Mother Toungue
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {partnerdetails &&
                                          partnerdetails.motherTongue &&
                                          partnerdetails
                                          ? partnerdetails.motherTongue
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {personalitydetails.eatingHabits ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Eating Habits
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {personalitydetails
                                          ? personalitydetails.eatingHabits
                                          : false}
                                      </td>
                                    </tr>
                                    <tr>
                                      {personalitydetails.drinkingHabits ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Drinking Habits
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {personalitydetails
                                          ? personalitydetails.drinkingHabits
                                          : false}
                                      </td>
                                    </tr>
                                    <tr>
                                      {personalitydetails.smokingHabits ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Smoking Habits
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {personalitydetails
                                          ? personalitydetails.smokingHabits
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {personalitydetails.bodyType ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Body Type
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {personalitydetails
                                          ? personalitydetails.bodyType
                                          : false}
                                      </td>
                                    </tr>
                                    <tr>
                                      {personalitydetails.physicalStatus ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Physical Status
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {personalitydetails
                                          ? personalitydetails.physicalStatus
                                          : false}
                                      </td>
                                    </tr>
                                  </tbody>
                                  <tbody>
                                    {" "}
                                    <tr>
                                      {userdetails && userdetails.religion ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Religion
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          paddingLeft: "600px",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {userdetails && userdetails.religion
                                          ? userdetails.religion
                                          : false}
                                      </td>
                                    </tr>
                                    <tr>
                                      {userdetails && userdetails.caste ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Caste
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {userdetails && userdetails.caste
                                          ? userdetails.caste
                                          : false}
                                      </td>
                                    </tr>
                                    <tr>
                                      {userdetails && userdetails.subCaste ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Sub Caste
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {userdetails && userdetails.subCaste
                                          ? userdetails.subCaste
                                          : false}
                                      </td>
                                    </tr>
                                  </tbody>{" "}
                                  <tbody>
                                    {" "}
                                    <tr>
                                      {userdetails &&
                                        userdetails.educationalQualification ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Educational Category
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {userdetails &&
                                          userdetails.educationalQualification
                                          ? userdetails.educationalQualification
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {userdetails &&
                                        userdetails.institutionName ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Institution Name
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {userdetails &&
                                          userdetails.institutionName
                                          ? userdetails.institutionName
                                          : false}
                                      </td>
                                    </tr>
                                    <tr>
                                      {userdetails && userdetails.occupation ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Occupation
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {userdetails && userdetails.occupation
                                          ? userdetails.occupation
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {userdetails &&
                                        userdetails.organization ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Organization
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {userdetails && userdetails.organization
                                          ? userdetails.organization
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {userdetails && userdetails.employedIn ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Employed In
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {userdetails && userdetails.employedIn
                                          ? userdetails.employedIn
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {userdetails &&
                                        userdetails.annualIncome ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Annual Income
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {userdetails && userdetails.annualIncome
                                          ? userdetails.annualIncome
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {userdetails &&
                                        userdetails.workingCountry ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Working Country
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {userdetails &&
                                          userdetails.workingCountry
                                          ? userdetails.workingCountry
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {userdetails &&
                                        userdetails.workingState ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Working State
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {userdetails && userdetails.workingState
                                          ? userdetails.workingState
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {userdetails &&
                                        userdetails.workingDistrict ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Working District
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {userdetails &&
                                          userdetails.workingDistrict
                                          ? userdetails.workingDistrict
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {userdetails &&
                                        userdetails.additionalDegree ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Additional Degree
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {userdetails &&
                                          userdetails.additionalDegree
                                          ? userdetails.additionalDegree
                                          : false}
                                      </td>
                                    </tr>
                                    <tr></tr>
                                  </tbody>{" "}
                                  <tbody>
                                    {" "}
                                    <tr>
                                      {profile.country ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Country
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {profile.country
                                          ? profile.country
                                          : false}
                                      </td>
                                    </tr>
                                    <tr>
                                      {profile.state ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          State
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {profile.state ? profile.state : false}
                                      </td>
                                    </tr>
                                    <tr>
                                      {profile.city ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          City
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {profile.city ? profile.city : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {userdetails &&
                                        userdetails.citizenship ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Citizenship
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {userdetails && userdetails.citizenship
                                          ? userdetails.citizenship
                                          : false}
                                      </td>
                                    </tr>
                                  </tbody>{" "}
                                  <tbody>
                                    {" "}
                                    <tr>
                                      {familydetails.familyValues ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Family Values
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {familydetails
                                          ? familydetails.familyValues
                                          : false}
                                      </td>
                                    </tr>
                                    <tr>
                                      {familydetails &&
                                        familydetails.financialStatus ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Family Status
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {familydetails &&
                                          familydetails.financialStatus &&
                                          familydetails
                                          ? familydetails.financialStatus
                                          : false}
                                      </td>
                                    </tr>
                                    <tr>
                                      {familydetails.familyType ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Family Type
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td
                                        style={{
                                          borderTop: "none",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {familydetails
                                          ? familydetails.familyType
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {familydetails.fatherOccupation ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Father's Occupation
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {familydetails
                                          ? familydetails.fatherOccupation
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {familydetails.motherOccupation ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Mothers's Occupation
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {familydetails
                                          ? familydetails.motherOccupation
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {familydetails.noOfBrothers ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          No.Of.Brother(s)
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {familydetails
                                          ? familydetails.noOfBrothers
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {familydetails.brothersMarried ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Brother(s) Married
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {familydetails
                                          ? familydetails.brothersMarried
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {familydetails.noOfSisters ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          No.Of.Sister(s)
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {familydetails
                                          ? familydetails.noOfSisters
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {familydetails.sistersMarried ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          Sister(s) Married
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {familydetails
                                          ? familydetails.sistersMarried
                                          : false}
                                      </td>
                                    </tr>{" "}
                                    <tr>
                                      {familydetails &&
                                        familydetails.aboutFamily ? (
                                        <td
                                          style={{
                                            borderTop: "none",
                                            fontWeight: "600",
                                            width: "420px",
                                          }}
                                        >
                                          About Family
                                        </td>
                                      ) : (
                                        false
                                      )}
                                      <td style={{ borderTop: "none" }}>
                                        {familydetails &&
                                          familydetails.aboutFamily
                                          ? familydetails.aboutFamily
                                          : false}
                                      </td>
                                    </tr>{" "}
                                  </tbody>
                                </table>{" "}
                              </div>
                            </div>
                          </Card>
                        </div>

                        <div className="profile-container">
                          <ProfileSection
                            title="About Myself"
                            onEdit={handleaboutMyselfEditClick}
                          >
                            <table className="profile-table">
                              <tbody>
                                <tr>
                                  <td className="label">A Few Word About Myself</td>
                                  <td>
                                    {(userDetails &&
                                      userDetails.aboutMyself) ||
                                      "None"}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </ProfileSection>
                          {/* EXPECTATIONS */}
                          <ProfileSection
                            title="Expectations"
                            onEdit={handleexpectEditClick}
                          >
                            <table className="profile-table">
                              <tbody>
                                <tr>
                                  <td className="label">What I'm Expecting</td>
                                  <td>
                                    {(userDetails &&
                                      userDetails.whatIExpecting) ||
                                      "None"}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </ProfileSection>

                          <ProfileSection
                            title="Basic Details"
                            onEdit={handleEditClick}
                          >
                            <table className="profile-table">
                              <tbody>
                                <tr>
                                  <td className="label">Name</td>
                                  <td>{profile.userName || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Profile Created For</td>
                                  <td>{profile.profileCreatedFor || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Gender</td>
                                  <td>{profile.gender || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Date of Birth</td>
                                  <td>{profile.dob || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Religion</td>
                                  <td>{profile.religion || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Kulam</td>
                                  <td>{profile.kulam || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Marital Status</td>
                                  <td>
                                    {" "}
                                    {userdetails && userdetails.maritalStatus}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Physical Status</td>
                                  <td>
                                    {(userdetails &&
                                      userdetails.physicalStatus) ||
                                      "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Height</td>
                                  <td>
                                    {" "}
                                    {(userdetails && userdetails.height) ||
                                      "None"}
                                  </td>
                                </tr>
                                {/* <tr>
                                  <td className="label">Phone</td>
                                  <td>{profile.phone || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Email</td>
                                  <td>{profile.email || "None"}</td>
                                </tr> */}

                                {/* <tr>
                                  <td className="label">Mother Tongue</td>
                                  <td>
                                    {" "}
                                    {(userdetails &&
                                      userdetails.motherTongue) ||
                                      "None"}
                                  </td>
                                </tr> */}
                                <tr>
                                  <td className="label">Weight</td>
                                  <td>
                                    {" "}
                                    {(userdetails && userdetails.weight) ||
                                      "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Body Type</td>
                                  <td>
                                    {" "}
                                    {(userdetails && userdetails.bodyType) ||
                                      "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Complexion</td>
                                  <td>
                                    {" "}
                                    {(userdetails && userdetails.complexion) ||
                                      "None"}
                                  </td>
                                </tr>



                                {/* <tr>
                                  <td className="label">About Myself</td>
                                  <td>
                                    {" "}
                                    {(userdetails && userdetails.aboutMyself) ||
                                      "None"}
                                  </td>
                                </tr> */}
                              </tbody>
                            </table>
                          </ProfileSection>

                          <ProfileSection
                            title="Contact Info"
                            onEdit={handleContactEditClick}
                          >
                            <table className="profile-table">
                              <tbody>
                                <tr>
                                  <td className="label">Phone Number</td>
                                  <td>{profile.phone || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Email ID</td>
                                  <td>{profile.email || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Father's Number</td>
                                  <td>{userFamily.member1Mobile || ""}</td>
                                </tr>
                                <tr>
                                  <td className="label">Mother's Number</td>
                                  <td>{userFamily.member2Mobile || ""}</td>
                                </tr>
                                <tr>
                                  <td className="label">Permanent Address</td>
                                  <td>{profile.permanentAddress || "None"}</td>
                                </tr>
                              </tbody>
                            </table>
                          </ProfileSection>




                          {/* EDUCATION & JOB */}
                          <ProfileSection
                            title="Education & Professional Details"
                            onEdit={handleEduEditClick}
                          >
                            <table className="profile-table">
                              <tbody>
                                <tr>
                                  <td className="label">Education</td>
                                  <td>
                                    {" "}
                                    {(userdetails && userdetails.education) ||
                                      "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Employed In</td>
                                  <td>
                                    {(userdetails &&
                                      userdetails.employedIn) ||
                                      "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Occupation</td>
                                  <td>
                                    {" "}
                                    {(userdetails && userdetails.occupation) ||
                                      "None"}
                                  </td>
                                </tr>
                                {/* <tr>
                                  <td className="label">Occupation Detail</td>
                                  <td>
                                    {(userdetails &&
                                      userdetails.occupationDetail) ||
                                      "None"}
                                  </td>
                                </tr> */}
                                {/* <tr>
                                  <td className="label">Employed In</td>
                                  <td>
                                    {" "}
                                    {(userdetails && userdetails.employedIn) ||
                                      "None"}
                                  </td>
                                </tr> */}
                                <tr>
                                  <td className="label">Monthly Income (Rupees)</td>
                                  <td>
                                    {userdetails && userdetails.monthlyIncome
                                      ? userdetails.monthlyIncome
                                      : "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Work Location</td>
                                  <td>
                                    {" "}
                                    {(userdetails &&
                                      userdetails.workLocation) ||
                                      "None"}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </ProfileSection>
                          <ProfileSection
                            title="Kulam & Kula Deiva Details"
                            onEdit={handleKulamDetailsEditClick}
                          >
                            <table className="profile-table">
                              <tbody>
                                <tr>
                                  <td className="label">Father Kulam</td>
                                  <td>{(horoscopedetails && horoscopedetails.fatherKulam) || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Mother Kulam</td>
                                  <td>{(horoscopedetails && horoscopedetails.motherKulam) || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Kula Deivam</td>
                                  <td>{(horoscopedetails && horoscopedetails.kulaDeivam) || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Temple Location</td>
                                  <td>{(horoscopedetails && horoscopedetails.templeLocation) || "None"}</td>
                                </tr>
                              </tbody>
                            </table>
                          </ProfileSection>

                          <ProfileSection
                            title="Family Details"
                            onEdit={handleFamilyEditClick}
                          >
                            <table className="profile-table">
                              <tbody>
                                {" "}
                                {/* <tr>
                                  <td className="label">About Father</td>
                                  <td>{familydetails.aboutFather || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">About Mother</td>
                                  <td>{familydetails.aboutMother || "None"}</td>
                                </tr> */}
                                <tr>
                                  <td className="label">Father Status</td>
                                  <td>
                                    {familydetails.fatherStatus || "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Mother Status</td>
                                  <td>
                                    {familydetails.motherStatus || "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Elder Brothers</td>
                                  <td>{familydetails.elderBrothers || "0"}</td>
                                </tr>
                                <tr>
                                  <td className="label">
                                    Elder Brothers Married
                                  </td>
                                  <td>
                                    {familydetails.elderBrothersMarried || "0"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Elder Sisters</td>
                                  <td>{familydetails.elderSisters || "0"}</td>
                                </tr>
                                <tr>
                                  <td className="label">
                                    Elder Sisters Married
                                  </td>
                                  <td>
                                    {familydetails.elderSistersMarried || "0"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Younger Brothers</td>
                                  <td>
                                    {familydetails.youngerBrothers || "0"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">
                                    Younger Brothers Married
                                  </td>
                                  <td>
                                    {familydetails.youngerBrothersMarried ||
                                      "0"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Younger Sisters</td>
                                  <td>{familydetails.youngerSisters || "0"}</td>
                                </tr>
                                <tr>
                                  <td className="label">
                                    Younger Sisters Married
                                  </td>
                                  <td>
                                    {familydetails.youngerSistersMarried || "0"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Family Status</td>
                                  <td>
                                    {familydetails.familyStatus || "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Family Type</td>
                                  <td>{familydetails.familyType || "None"}</td>
                                </tr>


                                {/* <tr>
                                  <td className="label">Member 1</td>
                                  <td>
                                    {familydetails.member1 || "None"} -{" "}
                                    {familydetails.member1Mobile || "N/A"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Member 2</td>
                                  <td>
                                    {familydetails.member2 || "None"} -{" "}
                                    {familydetails.member2Mobile || "N/A"}
                                  </td>
                                </tr> */}
                              </tbody>
                            </table>
                          </ProfileSection>

                          {/* LOCATION */}
                          <ProfileSection
                            title="Address Details"
                            onEdit={handleAddressDetailsEditClick}
                          >
                            <table className="profile-table">
                              <tbody>
                                <tr>
                                  <td className="label">About Your House</td>
                                  <td>{profile.aboutHouse || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Type of House</td>
                                  <td>{profile.typeOfHouse || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Permanent Address</td>
                                  <td>{profile.permanentAddress || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">State</td>
                                  <td>{profile.state || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">District</td>
                                  <td>{profile.district || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Taluk</td>
                                  <td>{profile.taluk || "None"}</td>
                                </tr>
                              </tbody>
                            </table>
                          </ProfileSection>

                          <ProfileSection
                            title="About Family"
                            onEdit={handleAboutFamilyEditClick}
                          >
                            <table className="profile-table">
                              <tbody>
                                <tr>
                                  <td className="label">About Family</td>
                                  <td>{userFamily.aboutFamily || "None"}</td>
                                </tr>
                              </tbody>
                            </table>
                          </ProfileSection>

                          <ProfileSection
                            title="Horoscope Details"
                            onEdit={handleRegEditClick}
                          >
                            <table className="profile-table">
                              <tbody>
                                <tr>
                                  <td className="label">Raasi</td>
                                  <td>{(horoscopedetails && horoscopedetails.raasi) || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Star</td>
                                  <td>{(horoscopedetails && horoscopedetails.star) || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Dhosam</td>
                                  <td>{(horoscopedetails && horoscopedetails.dhosam) || "None"}</td>
                                </tr>

                              </tbody>
                            </table>
                          </ProfileSection>

                          {/* <ProfileSection
                            title="House Images"
                            onEdit={handleHouseImagesEditClick}
                          >
                            {userdocumentdetails && (
                              <div style={{ marginBottom: "10px" }}>
                                <span
                                  className="badge"
                                  style={{
                                    borderRadius: "10px",
                                    fontWeight: "500",
                                    backgroundColor:
                                      (userdocumentdetails.housePic1Verified === 1 &&
                                        userdocumentdetails.housePic2Verified === 1 &&
                                        userdocumentdetails.housePic3Verified === 1 &&
                                        userdocumentdetails.housePic4Verified === 1)
                                        ? "green"
                                        : (userdocumentdetails.housePic1Verified === 1 ||
                                          userdocumentdetails.housePic2Verified === 1 ||
                                          userdocumentdetails.housePic3Verified === 1 ||
                                          userdocumentdetails.housePic4Verified === 1)
                                          ? "#2196F3"
                                          : userdocumentdetails.housePicVerified === 0
                                            ? "orange"
                                            : "red",
                                    color: "white",
                                    padding: "5px 12px",
                                  }}
                                >
                                  {(userdocumentdetails.housePic1Verified === 1 &&
                                    userdocumentdetails.housePic2Verified === 1 &&
                                    userdocumentdetails.housePic3Verified === 1 &&
                                    userdocumentdetails.housePic4Verified === 1)
                                    ? "Verified"
                                    : (userdocumentdetails.housePic1Verified === 1 ||
                                      userdocumentdetails.housePic2Verified === 1 ||
                                      userdocumentdetails.housePic3Verified === 1 ||
                                      userdocumentdetails.housePic4Verified === 1)
                                      ? "Partially Verified"
                                      : userdocumentdetails.housePicVerified === 0
                                        ? "Waiting"
                                        : "Rejected"}
                                </span>
                              </div>
                            )}
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", padding: "10px 0" }}>
                              {userdocumentdetails && userdocumentdetails.housePic1 && (
                                <div style={{ textAlign: "center" }}>
                                  <div style={{ position: "relative", display: "inline-block" }}>
                                    <img
                                      src={baseURL + userdocumentdetails.housePic1}
                                      alt="House 1"
                                      style={{
                                        width: "150px",
                                        height: "120px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        border: houseChecked.img1 ? "3px solid #4caf50" : "1px solid #ddd",
                                        cursor: "pointer"
                                      }}
                                      onClick={function () { setHouseChecked(function (prev) { return { ...prev, img1: !prev.img1 }; }); }}
                                    />
                                    <div
                                      onClick={function () { setHouseChecked(function (prev) { return { ...prev, img1: !prev.img1 }; }); }}
                                      style={{
                                        position: "absolute",
                                        top: "8px",
                                        right: "8px",
                                        width: "22px",
                                        height: "22px",
                                        borderRadius: "50%",
                                        border: houseChecked.img1 ? "none" : "2px solid #333",
                                        backgroundColor: houseChecked.img1 ? "#4caf50" : "#fff",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                      }}
                                    >
                                      {houseChecked.img1 && <span style={{ color: "#fff", fontSize: "12px", fontWeight: "bold" }}>✓</span>}
                                    </div>
                                  </div>
                                  <p style={{ fontSize: "12px", marginTop: "5px", color: "#666" }}>House Image 1</p>
                                </div>
                              )}
                              {userdocumentdetails && userdocumentdetails.housePic2 && (
                                <div style={{ textAlign: "center" }}>
                                  <div style={{ position: "relative", display: "inline-block" }}>
                                    <img
                                      src={baseURL + userdocumentdetails.housePic2}
                                      alt="House 2"
                                      style={{
                                        width: "150px",
                                        height: "120px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        border: houseChecked.img2 ? "3px solid #4caf50" : "1px solid #ddd",
                                        cursor: "pointer"
                                      }}
                                      onClick={function () { setHouseChecked(function (prev) { return { ...prev, img2: !prev.img2 }; }); }}
                                    />
                                    <div
                                      onClick={function () { setHouseChecked(function (prev) { return { ...prev, img2: !prev.img2 }; }); }}
                                      style={{
                                        position: "absolute",
                                        top: "8px",
                                        right: "8px",
                                        width: "22px",
                                        height: "22px",
                                        borderRadius: "50%",
                                        border: houseChecked.img2 ? "none" : "2px solid #333",
                                        backgroundColor: houseChecked.img2 ? "#4caf50" : "#fff",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                      }}
                                    >
                                      {houseChecked.img2 && <span style={{ color: "#fff", fontSize: "12px", fontWeight: "bold" }}>✓</span>}
                                    </div>
                                  </div>
                                  <p style={{ fontSize: "12px", marginTop: "5px", color: "#666" }}>House Image 2</p>
                                </div>
                              )}
                              {userdocumentdetails && userdocumentdetails.housePic3 && (
                                <div style={{ textAlign: "center" }}>
                                  <div style={{ position: "relative", display: "inline-block" }}>
                                    <img
                                      src={baseURL + userdocumentdetails.housePic3}
                                      alt="House 3"
                                      style={{
                                        width: "150px",
                                        height: "120px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        border: houseChecked.img3 ? "3px solid #4caf50" : "1px solid #ddd",
                                        cursor: "pointer"
                                      }}
                                      onClick={function () { setHouseChecked(function (prev) { return { ...prev, img3: !prev.img3 }; }); }}
                                    />
                                    <div
                                      onClick={function () { setHouseChecked(function (prev) { return { ...prev, img3: !prev.img3 }; }); }}
                                      style={{
                                        position: "absolute",
                                        top: "8px",
                                        right: "8px",
                                        width: "22px",
                                        height: "22px",
                                        borderRadius: "50%",
                                        border: houseChecked.img3 ? "none" : "2px solid #333",
                                        backgroundColor: houseChecked.img3 ? "#4caf50" : "#fff",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                      }}
                                    >
                                      {houseChecked.img3 && <span style={{ color: "#fff", fontSize: "12px", fontWeight: "bold" }}>✓</span>}
                                    </div>
                                  </div>
                                  <p style={{ fontSize: "12px", marginTop: "5px", color: "#666" }}>House Image 3</p>
                                </div>
                              )}
                              {userdocumentdetails && userdocumentdetails.housePic4 && (
                                <div style={{ textAlign: "center" }}>
                                  <div style={{ position: "relative", display: "inline-block" }}>
                                    <img
                                      src={baseURL + userdocumentdetails.housePic4}
                                      alt="House 4"
                                      style={{
                                        width: "150px",
                                        height: "120px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        border: houseChecked.img4 ? "3px solid #4caf50" : "1px solid #ddd",
                                        cursor: "pointer"
                                      }}
                                      onClick={function () { setHouseChecked(function (prev) { return { ...prev, img4: !prev.img4 }; }); }}
                                    />
                                    <div
                                      onClick={function () { setHouseChecked(function (prev) { return { ...prev, img4: !prev.img4 }; }); }}
                                      style={{
                                        position: "absolute",
                                        top: "8px",
                                        right: "8px",
                                        width: "22px",
                                        height: "22px",
                                        borderRadius: "50%",
                                        border: houseChecked.img4 ? "none" : "2px solid #333",
                                        backgroundColor: houseChecked.img4 ? "#4caf50" : "#fff",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                      }}
                                    >
                                      {houseChecked.img4 && <span style={{ color: "#fff", fontSize: "12px", fontWeight: "bold" }}>✓</span>}
                                    </div>
                                  </div>
                                  <p style={{ fontSize: "12px", marginTop: "5px", color: "#666" }}>House Image 4</p>
                                </div>
                              )}
                              {(!userdocumentdetails || (!userdocumentdetails.housePic1 && !userdocumentdetails.housePic2 && !userdocumentdetails.housePic3 && !userdocumentdetails.housePic4)) && (
                                <p style={{ color: "#999" }}>No house images uploaded</p>
                              )}
                              {userdocumentdetails && (userdocumentdetails.housePic1 || userdocumentdetails.housePic2 || userdocumentdetails.housePic3 || userdocumentdetails.housePic4) && (
                                <div style={{ marginLeft: "auto" }}>
                                  <select
                                    onChange={(e) => {
                                      if (e.target.value === "1") {
                                        HouseVerify(userdocumentdetails.userId, "verify");
                                      } else if (e.target.value === "0") {
                                        HouseVerify(userdocumentdetails.userId, "waiting");
                                      }
                                    }}
                                    value={
                                      (userdocumentdetails.housePic1 && userdocumentdetails.housePic1Verified === 1 &&
                                        (!userdocumentdetails.housePic2 || userdocumentdetails.housePic2Verified === 1) &&
                                        (!userdocumentdetails.housePic3 || userdocumentdetails.housePic3Verified === 1) &&
                                        (!userdocumentdetails.housePic4 || userdocumentdetails.housePic4Verified === 1))
                                        ? "1"
                                        : ((!userdocumentdetails.housePic1 || userdocumentdetails.housePic1Verified === 0) &&
                                          (!userdocumentdetails.housePic2 || userdocumentdetails.housePic2Verified === 0) &&
                                          (!userdocumentdetails.housePic3 || userdocumentdetails.housePic3Verified === 0) &&
                                          (!userdocumentdetails.housePic4 || userdocumentdetails.housePic4Verified === 0))
                                          ? "0"
                                          : ""
                                    }
                                    className="form-select"
                                  >
                                    <option value="">Select</option>
                                    <option value="1">Verify</option>
                                    <option value="0">Waiting</option>
                                  </select>
                                </div>
                              )}
                            </div>
                          </ProfileSection> */}

                          <ProfileSection
                            title="Other Assets of the Family"
                            onEdit={handleFamilyAssetsEditClick}
                          >
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", padding: "10px 0" }}>
                              {familydetails && familydetails.familyAssets ? (
                                familydetails.familyAssets.split(", ").map((asset, index) => (
                                  <span
                                    key={index}
                                    style={{
                                      display: "inline-block",
                                      padding: "8px 16px",
                                      borderRadius: "20px",
                                      backgroundColor: "#000",
                                      color: "#fff",
                                      fontSize: "13px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {asset.trim()}
                                  </span>
                                ))
                              ) : (
                                <span style={{ color: "#999" }}>No assets added</span>
                              )}
                            </div>
                          </ProfileSection>

                          {/* HOBBIES */}
                          <ProfileSection
                            title="Hobbies & Interests"
                            onEdit={handleHobbiesEditClick}
                          >
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", padding: "10px 0" }}>
                              {userdetails && userdetails.hobbies ? (
                                userdetails.hobbies.split(", ").map((hobby, index) => (
                                  <span
                                    key={index}
                                    style={{
                                      display: "inline-block",
                                      padding: "8px 16px",
                                      borderRadius: "20px",
                                      backgroundColor: "#000",
                                      color: "#fff",
                                      fontSize: "13px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {hobby.trim()}
                                  </span>
                                ))
                              ) : (
                                <span style={{ color: "#999" }}>No hobbies added</span>
                              )}
                            </div>
                          </ProfileSection>


                          {/* FAMILY DETAILS */}




                          {/* RELIGION & HOROSCOPE */}


                          {/* PARTNER DETAILS */}
                          {/* <ProfileSection
                            title="Partner Details"
                            onEdit={handlePartnerEditClick}
                          >
                            <table className="profile-table">
                              <tbody>
                                <tr>
                                  <td className="label">Height</td>
                                  <td>{partnerdetails.height || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Age</td>
                                  <td>{partnerdetails.age || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Marital Status</td>
                                  <td>
                                    {partnerdetails.maritalStatus || "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Mother Tongue</td>
                                  <td>
                                    {partnerdetails.motherTongue || "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Physical Status</td>
                                  <td>
                                    {partnerdetails.physicalStatus || "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Eating Habits</td>
                                  <td>
                                    {partnerdetails.eatingHabits || "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Drinking Habits</td>
                                  <td>
                                    {partnerdetails.drinkingHabits || "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Smoking Habits</td>
                                  <td>
                                    {partnerdetails.smokingHabits || "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Family Status</td>
                                  <td>
                                    {partnerdetails.familyStatus || "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Religion</td>
                                  <td>{partnerdetails.religion || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Caste</td>
                                  <td>{partnerdetails.caste || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Subcaste</td>
                                  <td>{partnerdetails.subcaste || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Dhosam</td>
                                  <td>{partnerdetails.dhosam || "None"}</td>
                                </tr>

                                <tr>
                                  <td className="label">Zodiac Star</td>
                                  <td>{partnerdetails.star || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Education</td>
                                  <td>{partnerdetails.education || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Employed In</td>
                                  <td>{partnerdetails.employedIn || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Occupation</td>
                                  <td>{partnerdetails.occupation || "None"}</td>
                                </tr>
                                <tr>
                                  <td className="label">Annual Income</td>
                                  <td>
                                    {partnerdetails.annualIncome || "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="label">Country</td>
                                  <td>
                                    {partnerdetails.locationCountry || "None"}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </ProfileSection> */}
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="2">
                    {userdocumentdetails.horoscope && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <h5>
                            Horoscope Verification:
                            <span
                              className="badge"
                              style={{
                                borderRadius: "10px",
                                fontWeight: "500",
                                backgroundColor:
                                  userdocumentdetails.horoscopeVerified === 0
                                    ? "orange"
                                    : "green",
                                color: "white",
                              }}
                            >
                              {userdocumentdetails.horoscopeVerified === 0
                                ? "Waiting"
                                : "Verified"}
                            </span>
                          </h5>

                          {/* Existing Horoscope Image */}
                          <img
                            src={baseURL + userdocumentdetails.horoscope}
                            style={{
                              width: "500px",
                              height: "600px",
                              cursor: "pointer",
                            }}
                            alt="Horoscope Image"
                            onClick={handleImageClick} // Trigger full-screen modal
                          />

                          {/* Upload New Horoscope Image */}
                          <div style={{ marginTop: "20px" }}>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => handleHoroscopeUpload(e)} // handle file upload
                            />
                          </div>
                        </div>

                        <div>
                          <div>
                            <h5>
                              <select
                                className="form-select"
                                onChange={(e) =>
                                  verifihoro(
                                    profile.id,
                                    e.target.value === "1"
                                      ? true
                                      : e.target.value === "0"
                                        ? false
                                        : ""
                                  )
                                }
                                value={
                                  userdocumentdetails.horoscopeVerified === 0 ||
                                    userdocumentdetails.horoscopeVerified === 1
                                    ? userdocumentdetails.horoscopeVerified
                                    : ""
                                }
                                aria-label="Default select example"
                              >
                                <option>Change Status</option>
                                <option value="0">Waiting</option>
                                <option value="1">Verify</option>
                              </select>
                            </h5>
                          </div>
                        </div>
                      </div>
                    )}
                  </TabPane>
                  <TabPane tabId="3">
                    {/* <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      {" "}
                      <Link to={"/updatedoc/" + id}>
                        <button
                          style={{
                            fontWeight: "500",
                            background: "green",
                            color: "white",
                            border: "None",
                          }}
                        >
                          {" "}
                          Edit
                        </button>
                      </Link>
                    </div> */}
                    <Row>
                      <div
                        className="row"
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <Col sm="12">
                          <div className="col ">
                            <div
                              className="mt-5"
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <div>
                                <h5>
                                  Aadhar
                                  {userdocumentdetails && (
                                    <span
                                      className="badge"
                                      style={{
                                        borderRadius: "10px",
                                        fontWeight: "500",
                                        marginLeft: "10px",
                                        backgroundColor:
                                          (userdocumentdetails.aadharFrontVerified === 1 && userdocumentdetails.aadharBackVerified === 1)
                                            ? "green"
                                            : (userdocumentdetails.aadharFrontVerified === 1 || userdocumentdetails.aadharBackVerified === 1)
                                              ? "#2196F3"
                                              : "orange",
                                        color: "white",
                                        padding: "5px 12px",
                                      }}
                                    >
                                      {(userdocumentdetails.aadharFrontVerified === 1 && userdocumentdetails.aadharBackVerified === 1)
                                        ? "Verified"
                                        : (userdocumentdetails.aadharFrontVerified === 1 || userdocumentdetails.aadharBackVerified === 1)
                                          ? "Partially Verified"
                                          : "Waiting"}
                                    </span>
                                  )}
                                </h5>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "30px",
                                    marginTop: "15px",
                                  }}
                                >
                                  {userdocumentdetails && userdocumentdetails.aadharFront && (
                                    <div style={{ textAlign: "center" }}>
                                      <h5 style={{ marginBottom: "10px" }}>Aadhar Front</h5>
                                      <div style={{ position: "relative", display: "inline-block" }}>
                                        <img
                                          src={baseURL + userdocumentdetails.aadharFront}
                                          alt="Aadhar Front"
                                          style={{
                                            width: "300px",
                                            height: "200px",
                                            objectFit: "cover",
                                            border: aadharChecked.front ? "3px solid #4caf50" : "1px solid #ccc",
                                            borderRadius: "6px",
                                            cursor: "pointer",
                                          }}
                                          onClick={function () { setAadharChecked(function (prev) { return { ...prev, front: !prev.front }; }); }}
                                        />
                                        <div
                                          onClick={function () { setAadharChecked(function (prev) { return { ...prev, front: !prev.front }; }); }}
                                          style={{
                                            position: "absolute",
                                            top: "10px",
                                            right: "10px",
                                            width: "24px",
                                            height: "24px",
                                            borderRadius: "50%",
                                            border: aadharChecked.front ? "none" : "2px solid #333",
                                            backgroundColor: aadharChecked.front ? "#4caf50" : "#fff",
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                          }}
                                        >
                                          {aadharChecked.front && <span style={{ color: "#fff", fontSize: "14px", fontWeight: "bold" }}>✓</span>}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {userdocumentdetails && userdocumentdetails.aadharBack && (
                                    <div style={{ textAlign: "center" }}>
                                      <h5 style={{ marginBottom: "10px" }}>Aadhar Back</h5>
                                      <div style={{ position: "relative", display: "inline-block" }}>
                                        <img
                                          src={baseURL + userdocumentdetails.aadharBack}
                                          alt="Aadhar Back"
                                          style={{
                                            width: "300px",
                                            height: "200px",
                                            objectFit: "cover",
                                            border: aadharChecked.back ? "3px solid #4caf50" : "1px solid #ccc",
                                            borderRadius: "6px",
                                            cursor: "pointer",
                                          }}
                                          onClick={function () { setAadharChecked(function (prev) { return { ...prev, back: !prev.back }; }); }}
                                        />
                                        <div
                                          onClick={function () { setAadharChecked(function (prev) { return { ...prev, back: !prev.back }; }); }}
                                          style={{
                                            position: "absolute",
                                            top: "10px",
                                            right: "10px",
                                            width: "24px",
                                            height: "24px",
                                            borderRadius: "50%",
                                            border: aadharChecked.back ? "none" : "2px solid #333",
                                            backgroundColor: aadharChecked.back ? "#4caf50" : "#fff",
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                          }}
                                        >
                                          {aadharChecked.back && <span style={{ color: "#fff", fontSize: "14px", fontWeight: "bold" }}>✓</span>}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {/* Dropdown for status change */}
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "10px",
                                    }}
                                  >
                                    <select
                                      onChange={(e) => {
                                        if (e.target.value === "1") {
                                          AadharVerify(userdocumentdetails.userId, "verify");
                                        } else if (e.target.value === "0") {
                                          AadharVerify(userdocumentdetails.userId, "waiting");
                                        }
                                      }}
                                      value={
                                        (userdocumentdetails.aadharFrontVerified === 1 && userdocumentdetails.aadharBackVerified === 1)
                                          ? "1"
                                          : (userdocumentdetails.aadharFrontVerified === 0 && userdocumentdetails.aadharBackVerified === 0)
                                            ? "0"
                                            : ""
                                      }
                                      className="form-select"
                                    >
                                      <option value="">Select</option>
                                      <option value="1">Verify</option>
                                      <option value="0">Waiting</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* <>
                              <div>
                                {profile && profile.images && (
                                  <img
                                    src={baseURL + profile.images}
                                    style={{
                                      width: "100px",
                                      height: "100px",
                                      cursor: "pointer",
                                    }}
                                    alt="Profile Image"
                                    onClick={handleImageClick} // Trigger full-screen modal on click
                                  />
                                )}
                              </div>

                              {/* Modal for full-screen image view *
                              {showModal && (
                                <div
                                  style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    backgroundColor: "rgba(0, 0, 0, 0.8)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    zIndex: 1000,
                                  }}
                                  onClick={handleCloseModal} // Close the modal when clicking outside the image
                                >
                                  <img
                                    src={baseURL + profile.images}
                                    alt="Full screen"
                                    style={{
                                      maxWidth: "90%",
                                      maxHeight: "90%",
                                      borderRadius: "8px",
                                    }}
                                  />
                                </div>
                              )}
                            </> */}
                          </div>
                          <hr />
                          <div className="mt-5">
                            <h5>
                              House Image Verification
                              {userdocumentdetails && (
                                <span
                                  className="badge"
                                  style={{
                                    borderRadius: "10px",
                                    fontWeight: "500",
                                    marginLeft: "10px",
                                    backgroundColor:
                                      (userdocumentdetails.housePic1Verified === 1 &&
                                        userdocumentdetails.housePic2Verified === 1 &&
                                        userdocumentdetails.housePic3Verified === 1 &&
                                        userdocumentdetails.housePic4Verified === 1)
                                        ? "green"
                                        : (userdocumentdetails.housePic1Verified === 1 ||
                                          userdocumentdetails.housePic2Verified === 1 ||
                                          userdocumentdetails.housePic3Verified === 1 ||
                                          userdocumentdetails.housePic4Verified === 1)
                                          ? "#2196F3"
                                          : userdocumentdetails.housePicVerified === 0
                                            ? "orange"
                                            : "red",
                                    color: "white",
                                    padding: "5px 12px",
                                  }}
                                >
                                  {(userdocumentdetails.housePic1Verified === 1 &&
                                    userdocumentdetails.housePic2Verified === 1 &&
                                    userdocumentdetails.housePic3Verified === 1 &&
                                    userdocumentdetails.housePic4Verified === 1)
                                    ? "Verified"
                                    : (userdocumentdetails.housePic1Verified === 1 ||
                                      userdocumentdetails.housePic2Verified === 1 ||
                                      userdocumentdetails.housePic3Verified === 1 ||
                                      userdocumentdetails.housePic4Verified === 1)
                                      ? "Partially Verified"
                                      : userdocumentdetails.housePicVerified === 0
                                        ? "Waiting"
                                        : "Rejected"}
                                </span>
                              )}
                            </h5>

                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "20px",
                                padding: "10px 0",
                              }}
                            >
                              {userdocumentdetails && userdocumentdetails.housePic1 && (
                                <div style={{ textAlign: "center" }}>
                                  <div style={{ position: "relative", display: "inline-block" }}>
                                    <img
                                      src={baseURL + userdocumentdetails.housePic1}
                                      alt="House 1"
                                      style={{
                                        width: "300px",
                                        height: "250px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        border: houseChecked.img1 ? "3px solid #4caf50" : "1px solid #ddd",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        setHouseChecked((prev) => ({ ...prev, img1: !prev.img1 }))
                                      }
                                    />
                                    <div
                                      onClick={() =>
                                        setHouseChecked((prev) => ({ ...prev, img1: !prev.img1 }))
                                      }
                                      style={{
                                        position: "absolute",
                                        top: "8px",
                                        right: "8px",
                                        width: "22px",
                                        height: "22px",
                                        borderRadius: "50%",
                                        border: houseChecked.img1 ? "none" : "2px solid #333",
                                        backgroundColor: houseChecked.img1 ? "#4caf50" : "#fff",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                      }}
                                    >
                                      {houseChecked.img1 && (
                                        <span
                                          style={{
                                            color: "#fff",
                                            fontSize: "12px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          ✓
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      marginTop: "5px",
                                      color: "#666",
                                    }}
                                  >
                                    House Image 1
                                  </p>
                                </div>
                              )}

                              {userdocumentdetails && userdocumentdetails.housePic2 && (
                                <div style={{ textAlign: "center" }}>
                                  <div style={{ position: "relative", display: "inline-block" }}>
                                    <img
                                      src={baseURL + userdocumentdetails.housePic2}
                                      alt="House 2"
                                      style={{
                                        width: "300px",
                                        height: "250px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        border: houseChecked.img2 ? "3px solid #4caf50" : "1px solid #ddd",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        setHouseChecked((prev) => ({ ...prev, img2: !prev.img2 }))
                                      }
                                    />
                                    <div
                                      onClick={() =>
                                        setHouseChecked((prev) => ({ ...prev, img2: !prev.img2 }))
                                      }
                                      style={{
                                        position: "absolute",
                                        top: "8px",
                                        right: "8px",
                                        width: "22px",
                                        height: "22px",
                                        borderRadius: "50%",
                                        border: houseChecked.img2 ? "none" : "2px solid #333",
                                        backgroundColor: houseChecked.img2 ? "#4caf50" : "#fff",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                      }}
                                    >
                                      {houseChecked.img2 && (
                                        <span
                                          style={{
                                            color: "#fff",
                                            fontSize: "12px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          ✓
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      marginTop: "5px",
                                      color: "#666",
                                    }}
                                  >
                                    House Image 2
                                  </p>
                                </div>
                              )}

                              {userdocumentdetails && userdocumentdetails.housePic3 && (
                                <div style={{ textAlign: "center" }}>
                                  <div style={{ position: "relative", display: "inline-block" }}>
                                    <img
                                      src={baseURL + userdocumentdetails.housePic3}
                                      alt="House 3"
                                      style={{
                                        width: "300px",
                                        height: "250px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        border: houseChecked.img3 ? "3px solid #4caf50" : "1px solid #ddd",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        setHouseChecked((prev) => ({ ...prev, img3: !prev.img3 }))
                                      }
                                    />
                                    <div
                                      onClick={() =>
                                        setHouseChecked((prev) => ({ ...prev, img3: !prev.img3 }))
                                      }
                                      style={{
                                        position: "absolute",
                                        top: "8px",
                                        right: "8px",
                                        width: "22px",
                                        height: "22px",
                                        borderRadius: "50%",
                                        border: houseChecked.img3 ? "none" : "2px solid #333",
                                        backgroundColor: houseChecked.img3 ? "#4caf50" : "#fff",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                      }}
                                    >
                                      {houseChecked.img3 && (
                                        <span
                                          style={{
                                            color: "#fff",
                                            fontSize: "12px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          ✓
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      marginTop: "5px",
                                      color: "#666",
                                    }}
                                  >
                                    House Image 3
                                  </p>
                                </div>
                              )}

                              {userdocumentdetails && userdocumentdetails.housePic4 && (
                                <div style={{ textAlign: "center" }}>
                                  <div style={{ position: "relative", display: "inline-block" }}>
                                    <img
                                      src={baseURL + userdocumentdetails.housePic4}
                                      alt="House 4"
                                      style={{
                                        width: "300px",
                                        height: "250px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        border: houseChecked.img4 ? "3px solid #4caf50" : "1px solid #ddd",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        setHouseChecked((prev) => ({ ...prev, img4: !prev.img4 }))
                                      }
                                    />
                                    <div
                                      onClick={() =>
                                        setHouseChecked((prev) => ({ ...prev, img4: !prev.img4 }))
                                      }
                                      style={{
                                        position: "absolute",
                                        top: "8px",
                                        right: "8px",
                                        width: "22px",
                                        height: "22px",
                                        borderRadius: "50%",
                                        border: houseChecked.img4 ? "none" : "2px solid #333",
                                        backgroundColor: houseChecked.img4 ? "#4caf50" : "#fff",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                      }}
                                    >
                                      {houseChecked.img4 && (
                                        <span
                                          style={{
                                            color: "#fff",
                                            fontSize: "12px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          ✓
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      marginTop: "5px",
                                      color: "#666",
                                    }}
                                  >
                                    House Image 4
                                  </p>
                                </div>
                              )}

                              {(!userdocumentdetails ||
                                (!userdocumentdetails.housePic1 &&
                                  !userdocumentdetails.housePic2 &&
                                  !userdocumentdetails.housePic3 &&
                                  !userdocumentdetails.housePic4)) && (
                                  <p style={{ color: "#999" }}>No house images uploaded</p>
                                )}

                              {userdocumentdetails &&
                                (userdocumentdetails.housePic1 ||
                                  userdocumentdetails.housePic2 ||
                                  userdocumentdetails.housePic3 ||
                                  userdocumentdetails.housePic4) && (
                                  <div style={{ marginLeft: "auto" }}>
                                    <select
                                      onChange={(e) => {
                                        if (e.target.value === "1") {
                                          HouseVerify(userdocumentdetails.userId, "verify");
                                        } else if (e.target.value === "0") {
                                          HouseVerify(userdocumentdetails.userId, "waiting");
                                        }
                                      }}
                                      value={
                                        (userdocumentdetails.housePic1 && userdocumentdetails.housePic1Verified === 1 &&
                                          (!userdocumentdetails.housePic2 || userdocumentdetails.housePic2Verified === 1) &&
                                          (!userdocumentdetails.housePic3 || userdocumentdetails.housePic3Verified === 1) &&
                                          (!userdocumentdetails.housePic4 || userdocumentdetails.housePic4Verified === 1))
                                          ? "1"
                                          : ((!userdocumentdetails.housePic1 || userdocumentdetails.housePic1Verified === 0) &&
                                            (!userdocumentdetails.housePic2 || userdocumentdetails.housePic2Verified === 0) &&
                                            (!userdocumentdetails.housePic3 || userdocumentdetails.housePic3Verified === 0) &&
                                            (!userdocumentdetails.housePic4 || userdocumentdetails.housePic4Verified === 0))
                                            ? "0"
                                            : ""
                                      }
                                      className="form-select"
                                    >
                                      <option value="">Select</option>
                                      <option value="1">Verify</option>
                                      <option value="0">Waiting</option>
                                    </select>
                                  </div>
                                )}
                            </div>
                          </div>
                          <hr />
                          {/* <div className="col ">
                            <div
                              className="mt-5"
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <div>
                                <h5>
                                  Educational Details
                                  {userdocumentdetails && (
                                    <span
                                      className="badge"
                                      style={{
                                        borderRadius: "10px",
                                        fontWeight: "500",
                                        backgroundColor:
                                          userdocumentdetails.educationDetailsVerified ===
                                            0
                                            ? "orange"
                                            : "green",
                                        color: "white",
                                      }}
                                    >
                                      {userdocumentdetails.educationDetailsVerified ===
                                        0
                                        ? "Waiting"
                                        : userdocumentdetails.educationDetailsVerified ===
                                          1
                                          ? "Verified"
                                          : "Rejected"}
                                    </span>
                                  )}
                                </h5>
                              
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "50px",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div>
                                    <img
                                      src={
                                        baseURL +
                                        userdocumentdetails.educationDetails
                                      }
                                      alt="Educational image"
                                      style={{
                                        width: "350px",
                                        height: "250px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                      }}
                                    />
                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "10px",
                                    }}
                                  >
                                    <select
                                      onChange={(e) =>
                                        verifieds(
                                          userdocumentdetails.userId,
                                          e.target.value === "1"
                                            ? true
                                            : e.target.value === "0"
                                              ? false
                                              : ""
                                        )
                                      }
                                      value={
                                        userdocumentdetails.educationDetailsVerified ===
                                          1
                                          ? "1"
                                          : userdocumentdetails.educationDetailsVerified ===
                                            0
                                            ? "0"
                                            : ""
                                      }
                                      className="form-select"
                                    >
                                      <option value="">Select</option>
                                      <option value="1">Verify</option>
                                      <option value="0">Waiting</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> */}
                          {/* <hr /> */}

                          <>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div>
                                <div>
                                  {" "}
                                  <h5>About Myself Verification</h5>{" "}
                                  {userdetails &&
                                    userdetails.aboutMyselfUpload && (
                                      <p>
                                        About User Upload Date :{" "}
                                        {userdetails &&
                                          userdetails.aboutMyselfUpload}
                                      </p>
                                    )}
                                </div>
                                <div>
                                  {userdetails && userdetails.aboutMyself && (
                                    <FormControl>
                                      <Label for="aboutUser">
                                        About Myself
                                      </Label>
                                      <Input
                                        name="createdfor"
                                        value={
                                          userdetails && userdetails.aboutMyself
                                            ? userdetails.aboutMyself
                                            : ""
                                        }
                                        type="textarea"
                                        id="aboutUser"
                                        style={{
                                          textTransform: "capitalize",
                                          marginBottom: "10px",
                                          width: "1000px",
                                          height: "100px",
                                        }}
                                        onChange={(event) => {
                                          setaboutchange(event.target.value);
                                        }}
                                      />
                                    </FormControl>
                                  )}
                                </div>
                              </div>
                              <div>
                                {" "}
                                <div>
                                  <select
                                    className="form-select"
                                    onChange={() =>
                                      verifyAbout(userdetails.userId)
                                    }
                                    value={
                                      userdetails.aboutMyselfVerified === "0" ||
                                        userdetails.aboutMyselfVerified === "1"
                                        ? userdetails.aboutMyselfVerified
                                        : ""
                                    } // Handle the placeholder
                                    aria-label="Default select example"
                                  >
                                    <option>Change Status</option>
                                    <option value="0">Waiting</option>
                                    <option value="1">Verify</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <hr />
                          </>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <div>
                              <div>
                                {" "}
                                <h5>About Family Verification</h5>
                                {familydetails &&
                                  familydetails.aboutFamilyUpload && (
                                    <p>
                                      About Family Upload Date :{" "}
                                      {familydetails &&
                                        familydetails.aboutFamilyUpload}
                                    </p>
                                  )}
                              </div>
                              <div>
                                {familydetails && familydetails.aboutFamily && (
                                  <FormControl>
                                    <Label for="aboutUser">About Family</Label>
                                    <Input
                                      name="createdfor"
                                      value={
                                        familydetails &&
                                          familydetails.aboutFamily
                                          ? familydetails.aboutFamily
                                          : ""
                                      }
                                      type="textarea"
                                      id="aboutUser"
                                      style={{
                                        textTransform: "capitalize",
                                        marginBottom: "10px",
                                        width: "1000px",
                                        height: "100px",
                                      }}
                                      onChange={(event) => {
                                        setFamilyChange(event.target.value);
                                      }}
                                    />
                                  </FormControl>
                                )}
                              </div>
                            </div>
                            <div>
                              {" "}
                              <div>
                                <select
                                  className="form-select"
                                  onChange={(e) =>
                                    verifyFamily(
                                      familydetails.userId,
                                      e.target.value
                                    )
                                  } // Pass selected value
                                  value={
                                    familydetails.familyVerified === "0" ||
                                      familydetails.familyVerified === "1"
                                      ? familydetails.familyVerified
                                      : ""
                                  } // Handle the placeholder
                                  aria-label="Default select example"
                                >
                                  <option value="" disabled>
                                    Change Status
                                  </option>{" "}
                                  {/* Placeholder option */}
                                  <option value="0">Waiting</option>{" "}
                                  {/* '0' means 'Waiting' */}
                                  <option value="1">Verify</option>{" "}
                                  {/* '1' means 'Verify' */}
                                </select>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </div>{" "}
                    </Row>
                  </TabPane>
                  <TabPane tabId="6">
                    <Row>
                      <div className="row">
                        <div className="col">
                          <div>
                            <h5>Profile Image Verification</h5>

                            {!imageSrc && (
                              <input
                                type="file"
                                accept="image/*"
                                onChange={handleImageSelect}
                              />
                            )}

                            {imageSrc && (
                              <div
                                style={{
                                  display: "flex",
                                  gap: "25px",
                                  marginTop: "20px",
                                }}
                              >
                                {/* ✅ Croppper */}
                                <div>
                                  <Cropper
                                    src={imageSrc}
                                    style={{ height: 200, width: 350 }}
                                    ref={cropperRef}
                                    aspectRatio={1}
                                    viewMode={1}
                                    background={false}
                                    guides={false}
                                    cropBoxResizable={true}
                                    movable={true}
                                    zoomable={true}
                                    dragMode="move"
                                    cropBoxMovable={true}
                                    rounded={true}
                                  />

                                  <button
                                    onClick={handleCropAPI}
                                    style={{
                                      marginTop: "15px",
                                      background: "#4caf50",
                                      color: "#fff",
                                      padding: "10px 18px",
                                      borderRadius: "6px",
                                      border: "none",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Crop & Upload
                                  </button>
                                </div>

                                {/* ✅ Preview + Verify */}
                                {croppedImage && (
                                  <div style={{ marginTop: "-20px" }}>
                                    <h6>Cropped Preview</h6>
                                    <img
                                      src={croppedImage}
                                      alt="Preview"
                                      style={{
                                        width: 200,
                                        height: 200,

                                        objectFit: "cover",
                                      }}
                                    />

                                    {/* ✅ Dropdown verify */}
                                    <div style={{ marginTop: "15px" }}>
                                      <label style={{ fontWeight: "600" }}>
                                        Verification Status
                                      </label>

                                      <select
                                        style={{
                                          display: "block",
                                          padding: "8px 12px",
                                          borderRadius: "6px",
                                          border: "1px solid #ccc",
                                          marginTop: "5px",
                                          width: "180px",
                                        }}
                                        onChange={(e) =>
                                          handleVerify(e.target.value)
                                        }
                                      >
                                        <option value="">
                                          -- Select Status --
                                        </option>
                                        <option value="1">Verified</option>

                                        <option value="0"> Rejected</option>
                                      </select>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                          <div style={{ padding: "10px" }}>
                            <h3 style={{ marginBottom: "20px" }}>
                              Multiple Image Verification
                            </h3>

                            {renderBlock(
                              "Image 1",
                              imageSrc1,
                              setImageSrc1,
                              cropperRef1,
                              cropped1,
                              setCropped1,
                              "image1",
                              0
                            )}
                            {renderBlock(
                              "Image 2",
                              imageSrc2,
                              setImageSrc2,
                              cropperRef2,
                              cropped2,
                              setCropped2,
                              "image2",
                              1
                            )}
                            {renderBlock(
                              "Image 3",
                              imageSrc3,
                              setImageSrc3,
                              cropperRef3,
                              cropped3,
                              setCropped3,
                              "image3",
                              2
                            )}
                            {renderBlock(
                              "Image 4",
                              imageSrc4,
                              setImageSrc4,
                              cropperRef4,
                              cropped4,
                              setCropped4,
                              "image4",
                              3
                            )}

                            <button
                              onClick={saveAllVerification}
                              style={{
                                marginTop: "20px",
                                padding: "12px 25px",
                                background: "#1976d2",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                              }}
                            >
                              Save All Verification
                            </button>
                          </div>
                        </div>
                      </div>{" "}
                    </Row>
                  </TabPane>
                  <TabPane tabId="7">
                    <Row>
                      <h5>Update MemberShip Plan</h5>
                      <div className="row">
                        <div>
                          <h5>
                            Membership plan :
                            <span
                              className="badge"
                              style={{
                                borderRadius: "10px",
                                fontWeight: "500",
                                backgroundColor: "black",
                                textTransform: "capitalize",
                              }}
                            >
                              {membershipName || "Not Assigned"}
                            </span>{" "}
                          </h5>
                          <h5>
                            {/* <p>
                              Accessed Mobile Number :{" "}
                              {profile && profile.numberOfAccess}
                            </p> */}
                            <span>
                              <FormControl>
                                <select
                                  className="form-select mt-3 mb-3"
                                  value={membershipid}
                                  onChange={(event) => {
                                    setMembershipid(event.target.value);
                                  }}
                                >
                                  <option value="" disabled>
                                    Select Membership Plan
                                  </option>
                                  {membershiplist &&
                                    Array.isArray(membershiplist) &&
                                    membershiplist.map((membership) => (
                                      <option
                                        key={membership.id}
                                        value={membership.id.toString()}
                                      >
                                        {membership.name}
                                        {membershipName && membership.name.toLowerCase() === membershipName.toLowerCase()}
                                      </option>
                                    ))}
                                </select>
                              </FormControl>
                            </span>
                          </h5>
                          <h5>
                            <span>
                              <FormControl>
                                <Label for="createdFor">Remarks</Label>
                                <Input
                                  name="createdfor"
                                  type="textarea"
                                  id="createdFor"
                                  style={{
                                    textTransform: "capitalize",
                                    marginBottom: "10px",
                                  }}
                                  onChange={(e) => {
                                    setRemarks(e.target.value);
                                  }}
                                ></Input>
                              </FormControl>
                            </span>
                          </h5>
                          <Button
                            style={{ background: "black" }}
                            onClick={activeMembershipManual}
                          >
                            Submit
                          </Button>
                        </div>
                        {/* 
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Button
                            style={{ background: "black" }}
                            onClick={() => {}}
                          >
                            Submit
                          </Button>
                        </div> */}
                      </div>{" "}
                    </Row>
                  </TabPane>{" "}
                  <TabPane tabId="11">
                    <Row>
                      {Array.isArray(proShortList) &&
                        proShortList.length > 0 ? (
                        proShortList.map((user, index) => {
                          return (
                            <Usercard
                              key={index}
                              profileId={user.profileId}
                              id={user.id}
                              name={user.userName}
                              image={user.images}
                              age={user.age}
                              gender={user.gender}
                              dob={user.dob}
                            // status={user.status}
                            // state={user.state}
                            />
                          );
                        })
                      ) : (
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <h3> Profile Not Found</h3>
                        </div>
                      )}
                    </Row>
                  </TabPane>{" "}
                  <TabPane tabId="12">
                    <Row>
                      {" "}
                      {Array.isArray(shortList) && shortList.length > 0 ? (
                        shortList.map((user, index) => {
                          return (
                            <Usercard
                              key={index}
                              profileId={user.profileId}
                              id={user.id}
                              name={user.userName}
                              image={user.images}
                              age={user.age}
                              gender={user.gender}
                              dob={user.dob}
                            // status={user.status}
                            // state={user.state}
                            />
                          );
                        })
                      ) : (
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <h3> Profile Not Found</h3>
                        </div>
                      )}
                    </Row>
                  </TabPane>{" "}
                  <TabPane tabId="13">
                    <Row>
                      {" "}
                      {Array.isArray(likeMyProfile) &&
                        likeMyProfile.length > 0 ? (
                        likeMyProfile.map((user, index) => {
                          return (
                            <Usercard
                              key={index}
                              id={user.id}
                              profileId={user.profileId}
                              name={user.userName}
                              image={user.images}
                              age={user.age}
                              gender={user.gender}
                              dob={user.dob}
                            // status={user.status}
                            // state={user.state}
                            />
                          );
                        })
                      ) : (
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <h3> Profile Not Found</h3>
                        </div>
                      )}
                    </Row>
                  </TabPane>{" "}
                  <TabPane tabId="14">
                    <Row>
                      {" "}
                      {Array.isArray(likeProfile) && likeProfile.length > 0 ? (
                        likeProfile.map((user, index) => {
                          return (
                            <Usercard
                              key={index}
                              id={user.id}
                              profileId={user.profileId}
                              name={user.userName}
                              image={user.images}
                              age={user.age}
                              gender={user.gender}
                              dob={user.dob}
                            // status={user.status}
                            // state={user.state}
                            />
                          );
                        })
                      ) : (
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <h3> Profile Not Found</h3>
                        </div>
                      )}
                    </Row>
                  </TabPane>{" "}
                </TabContent>
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default dashboard8;
